import { commonJson } from '../../Cases/constants'
import { PAN, CIN,NAME,LEI,GST, BSE, NSE, GST_ANALYSIS_REQUIRED_FIELDS, GST_ANALYSIS_NOT_REQUIRED_FIELDS, BANK_STATEMENT_ANALYSIS_REQUIRED_FIELDS, BANK_STATEMENT_ANALYSIS_NOT_REQUIRED_FIELDS,ZIGRAM, INDIVIDUAL, ORGANIZATION} from '../../Cases/CommonComponent/DataAutomationDetails/constants'
// import sectionData from '../DO/SectionData.json'
/* export const showSingleCase=(param)=> {
    let singleCase;
    dummydata.forEach((data) => {
         if(param===data.caseNo){
            singleCase=data;
          }
    });
    return singleCase;
} */
/* export const showSections = (param) => {
    let singleCase;
    sectionData.forEach((data) => {
        if (param === data.caseNo) {
            singleCase = data.sections;
        }
    });
    return singleCase;
} */
export const activeTab = (param) => {

    let singleTab;
    /* sectionData.forEach((data) => {
        if (param === data.caseNo) {
            singleTab = data.sections[0].subcaseNo;
        }
    }); */
    singleTab = param.data[0];
    return singleTab;
}

export const getSurveyId = (caseData) => {
    let sectionTemplateIdList = [], requestBody;
    let set = new Set();
    caseData.tasks.forEach(element => {
        element.surveys.forEach(survey => {
            // sectionTemplateIdList.push(survey.sectionTemplateId);
            set.add(survey.sectionTemplateId);
        })
    });
    set.forEach(sectionTemplate => {
        sectionTemplateIdList.push(sectionTemplate);
    })
    requestBody = {
        counterpartyId: caseData.counterpartyId,
        sectionTemplateIds: sectionTemplateIdList
    }
    return requestBody
}

export const changeOrder = (newOrder) => {
    // let singleCase;
    /* for(let i=0;i<newOrder.length;i++)
    {
        newOrder[i].order=i;
    } */
    newOrder.forEach((element, index) => {
        element.order = index
    });
    return newOrder;
}


export const xbrlFileStatusCheck = (status) => {
    let flag = false;
    switch (status) {
        case 'PENDING':
            flag = false;
            break;
        case 'PROCESSING':
            flag = false;
            break;
        case 'SUCCESS':
            flag = true;
            break;
        case 'FAILURE':
            flag = true;
            break;
        default: flag = false;
    }
    return flag
}

export const setKycRequestBodyDataAutomation=(kycAutomationData,kycCrawlerData,metadata)=>{
    let requestBody = [], 
    tempMetadata = { 
        counterpartyName: kycCrawlerData.counterpartyName, 
        corporateId: metadata.corporateId, 
        counterpartyId: metadata.counterpartyId, 
        caseId: metadata.caseId,
        panNo: kycCrawlerData.panNo,
        gstNo: kycCrawlerData.gstNo,
        participantName:kycCrawlerData.participantName,
        counterpartyAddress:  kycCrawlerData.counterpartyAddress
    };
   


    if (kycAutomationData.PAN) {
        requestBody.push({
            ...tempMetadata,
            crawlerName: 'PAN',
            panNumber:kycCrawlerData.panNumber
        })
    }
    if (kycAutomationData.GST_FILING) {
        requestBody.push({
            ...tempMetadata,
            crawlerName: 'GST_FILING',
            gstNumber:kycCrawlerData.gstNumber,
            fy:kycCrawlerData.fy
        })
    }
    if (kycAutomationData.BANK) {
        requestBody.push({
            ...tempMetadata,
            crawlerName: 'BANK',
            accountNo:kycCrawlerData.accountNo,
            ifscCode:kycCrawlerData.ifscCode
        })
    }

    if (kycAutomationData.VEHICLE_NUMBER) {
        requestBody.push({
            ...tempMetadata,
            crawlerName: 'VEHICLE_NUMBER',
            vehicleNumber:kycCrawlerData.vehicleNumber,
        })
    }

    if (kycAutomationData.EMAIL) {
        requestBody.push({
            ...tempMetadata,
            crawlerName: 'EMAIL',
            emailId:kycCrawlerData.emailId,
        })
    }
    if (kycAutomationData.CHALLAN) {
        requestBody.push({
            ...tempMetadata,
            crawlerName: 'CHALLAN',
            challanVehicleNumber:kycCrawlerData.challanVehicleNumber,
            last5DigitsOfChasisNo:kycCrawlerData.last5DigitsOfChasisNo
        })
    }



    if (kycAutomationData.FSSAI_CERTIFICATE) {
        requestBody.push({
            ...tempMetadata,
            crawlerName: 'FSSAI_CERTIFICATE',
            fssaiLicenseNumber:kycCrawlerData.fssaiLicenseNumber
        })
    }

    if (kycAutomationData.TAN) {
        requestBody.push({
            ...tempMetadata,
            crawlerName: 'TAN',
            tanNumber:kycCrawlerData.tanNumber
        })
    }

    return {requestBody}
}

export const setRequestBodyDataAutomation = (dataAutomation, metadata, companyNameOnAgency, internationalXmlData, latestXbrlXmlFile, previousXbrlXmlFile) => {
    let requestBody = [], 
    tempMetadata = { 
        counterpartyName: metadata.counterpartyName, 
        corporateId: metadata.corporateId, 
        counterpartyId: metadata.counterpartyId, 
        caseId: metadata.caseId,
        panNo: metadata.panNo,
        counterpartyAddress:  metadata.counterpartyAddress,
        gstNo: metadata.gstNo,
    };
    if ("API" == metadata.requestType) {
        tempMetadata = { ...tempMetadata, requestType: "API" }
    }
    if (dataAutomation.GST) {
        if (metadata.gstNo) {
            requestBody.push({
                ...tempMetadata,
                crawlerName: 'GST',
                crawlerId: [metadata.gstNo],
                panNo: metadata.panNo ? metadata.panNo : metadata.gstNo.substring(2, 12)
            });
        }else if (metadata.panNo) {
            requestBody.push({
                ...tempMetadata,
                crawlerName: 'GST',
                crawlerId: [""],
            });
        }
    }
    if (dataAutomation.PAN) {
        requestBody.push({
            ...tempMetadata,
            crawlerName: 'PAN',
            crawlerId: [metadata.PAN]
        })
    }
    if (dataAutomation.MCA) {
        requestBody.push({
            ...tempMetadata,
            crawlerName: 'MCA',
            crawlerId: [metadata.MCA]
        })
    }
    if (dataAutomation.DIN) {
        requestBody.push({
            ...tempMetadata,
            crawlerName: 'DIN',
            crawlerId: [metadata.DIN]
        })
    }
    if (dataAutomation.RATINGS) {
        requestBody.push({
            ...tempMetadata,
            crawlerName: 'RATINGS',
            crawlerId: [metadata.RATINGS],
            ratingsSearchType: metadata.ratingsSearchType
        })
    }
    if (dataAutomation.STOCK_EXCHANGE) {
        requestBody.push({
            ...tempMetadata,
            crawlerName: 'STOCK_EXCHANGE',
            crawlerId: [metadata.STOCK_EXCHANGE],
            stockType: metadata.stockType
        })
    }
    if (dataAutomation.EPF) {
        let tempCrawlerId = metadata.EPF.split(",");
        requestBody.push({
            ...tempMetadata,
            crawlerName: 'EPF',
            crawlerId: tempCrawlerId
        })
    }
    if (dataAutomation.INTERNATIONAL) {
        requestBody.push({
            ...tempMetadata,
            crawlerName: 'INTERNATIONAL',
            crawlerId: [metadata.INTERNATIONAL],
            internationalXml: internationalXmlData
        })
    }
    if (dataAutomation.XBRL) {
        requestBody.push({
            ...tempMetadata,
            crawlerName: 'XBRL',
            crawlerId: [latestXbrlXmlFile != null ? latestXbrlXmlFile.name : null, previousXbrlXmlFile != null ? previousXbrlXmlFile.name : null]
        })
    }
    if (dataAutomation.NEWS) {
        delete requestBody.counterpartyName;
        requestBody.push({
            ...tempMetadata,
            crawlerName: 'NEWS',
            crawlerId: [metadata.NEWS ? metadata.NEWS : metadata.counterpartyName]
        })
    }
    if (dataAutomation.SOCIALMEDIA) {
        let socialMediaName = ""
        if (metadata.socialMediaName){
            console.log("social media updated name")
            socialMediaName = metadata.socialMediaName;
        }
        if (metadata.socialMediaAddress){
            console.log("social media updated address")
            tempMetadata.counterpartyAddress = metadata.socialMediaAddress;
        }

        requestBody.push({
            ...tempMetadata,
            crawlerName: 'SOCIALMEDIA',
            crawlerId: [""],
            socialmediaName: socialMediaName
        })
    }
    if (dataAutomation.LEI) {
        requestBody.push({
            ...tempMetadata,
            crawlerName: 'LEI',
            crawlerId: [metadata.LEI],
            leiSearchType: metadata.leiSearchType
        })
    }
    if (dataAutomation.IEC) {
        requestBody.push({
            ...tempMetadata,
            crawlerName: 'IEC',
            crawlerId: [metadata.iecIdentifier],
            iecCompanyName: metadata.iecCompanyName
        })
    }
    if (dataAutomation.UDYAM) {
        requestBody.push({
            ...tempMetadata,
            crawlerName: 'UDYAM',
            crawlerId: [metadata.udyamIdentifier]
        })
    }
    if (dataAutomation.UDYOG) {
        requestBody.push({
            ...tempMetadata,
            crawlerName: 'UDYOG',
            crawlerId: [metadata.udyogIdentifier]
        })
    }
    if (dataAutomation.NICCODE_SEARCH) {
        requestBody.push({
            ...tempMetadata,
            crawlerName: 'NIC',
            crawlerId: [metadata.nicCode, metadata.nicCodeDescription]
        })
    }
    if (dataAutomation.GST_ANALYSIS) {
        requestBody.push({
            ...tempMetadata,
            crawlerName: 'GST_ANALYSIS',
            crawlerId: [metadata.GST_ANALYSIS],
            [GST_ANALYSIS_REQUIRED_FIELDS.fromDate]: metadata[GST_ANALYSIS_REQUIRED_FIELDS.fromDate],
            [GST_ANALYSIS_REQUIRED_FIELDS.toDate]: metadata[GST_ANALYSIS_REQUIRED_FIELDS.toDate],
            [GST_ANALYSIS_REQUIRED_FIELDS.email]: metadata[GST_ANALYSIS_REQUIRED_FIELDS.email],
            [GST_ANALYSIS_NOT_REQUIRED_FIELDS.phoneNo]: metadata[GST_ANALYSIS_NOT_REQUIRED_FIELDS.phoneNo]
        })
    }
    if (dataAutomation.BANK_STATEMENT_ANALYSIS) {
        requestBody.push({
            ...tempMetadata,
            crawlerName: 'BANK_STATEMENT_ANALYSIS',
            crawlerId: [metadata.BANK_STATEMENT_ANALYSIS],
            [BANK_STATEMENT_ANALYSIS_REQUIRED_FIELDS.bsaEntityType]: metadata[BANK_STATEMENT_ANALYSIS_REQUIRED_FIELDS.bsaEntityType],
            [BANK_STATEMENT_ANALYSIS_REQUIRED_FIELDS.bsaAccountType]: metadata[BANK_STATEMENT_ANALYSIS_REQUIRED_FIELDS.bsaAccountType],
            [BANK_STATEMENT_ANALYSIS_REQUIRED_FIELDS.bsaBankName]: metadata[BANK_STATEMENT_ANALYSIS_REQUIRED_FIELDS.bsaBankName],
            [BANK_STATEMENT_ANALYSIS_NOT_REQUIRED_FIELDS.bsaSanctionLimit]: metadata[BANK_STATEMENT_ANALYSIS_NOT_REQUIRED_FIELDS.bsaSanctionLimit],
            [BANK_STATEMENT_ANALYSIS_NOT_REQUIRED_FIELDS.bsaRelatedPartyKeywords]: metadata[BANK_STATEMENT_ANALYSIS_NOT_REQUIRED_FIELDS.bsaRelatedPartyKeywords]
        })
    }
    if (dataAutomation.ITR_ANALYSIS) {
        requestBody.push({
            ...tempMetadata,
            crawlerName: 'ITR_ANALYSIS',
            'email': metadata['email'],
        })
    }
    if (dataAutomation.RETAIL_BUREAU) {
        requestBody.push({
            ...tempMetadata,
            crawlerName: 'RETAIL_BUREAU',
            firstName: metadata.firstName,
            middleName: metadata.middleName,
            lastName: metadata.lastName,
            bureauName: metadata.bureauName,
            address: metadata.address,
            state: metadata.state,
            pinCode: metadata.pinCode,
            mobileNo: metadata.mobileNo,
            emailId: metadata.emailId, 
            email: metadata.email,//registered email
            identity: metadata.identity,
            dateOfBirth: metadata.dateOfBirth,
            gender: metadata.gender,
            retailBureauRequestType: metadata.retailBureauRequestType,
            otp:metadata.otp
        })
    }
    if (dataAutomation.ITR_ANALYSIS) {
        requestBody.push({
            ...tempMetadata,
            crawlerName: 'ITR_ANALYSIS',
            'email': metadata['email'],
        })
    }

    if (dataAutomation.EMAIL) {
        requestBody.push({
            ...tempMetadata,
            crawlerName: 'EMAIL',
            'emailId': metadata['emailId'],
        })
    }

    if (dataAutomation.ZIGRAM) {
        requestBody.push({
            ...tempMetadata,
            crawlerName: 'ZIGRAM',
            crawlerId: [metadata.ZIGRAM],
            reportType: metadata.reportType
        })
    }

    if (dataAutomation.LEGAL) {
        tempMetadata.counterpartyName = metadata.LEGAL_name;
        requestBody.push({
            ...tempMetadata,
            crawlerName: 'LEGAL',
            nameMatchType: metadata.legalMatchType,
            state: metadata.state
        })

    }
    return {requestBody}
}

export const setRatingRequestBody = (companyNameOnAgency) => {

    let requestBody = {}
    let crisilName = null
    let crisilDeepLink = null
    let icraName = null
    let icraDeepLink = null
    let careName = null
    let careDeepLink = null
    let brickworkName = null
    let brickworkDeepLink = null
    let indiaratingsName = null
    let indiaratingsDeepLink = null
    let acuiteName = null
    let acuiteDeepLink = null
    if (companyNameOnAgency !== undefined && companyNameOnAgency !== null) {
        if (Object.keys(companyNameOnAgency).length > 0) {
            if (companyNameOnAgency.ratingDataModel !== undefined && companyNameOnAgency.ratingDataModel !== null) {
                if (companyNameOnAgency.ratingDataModel.crisilRating !== undefined && companyNameOnAgency.ratingDataModel.crisilRating !== null) {
                    if (companyNameOnAgency.ratingDataModel.crisilRating.agencyCompanyName !== undefined && companyNameOnAgency.ratingDataModel.crisilRating.agencyCompanyName !== null) {
                        crisilName = companyNameOnAgency.ratingDataModel.crisilRating.agencyCompanyName;
                        crisilDeepLink = companyNameOnAgency.ratingDataModel.crisilRating.deepLink;
                    }
                }

                if (companyNameOnAgency.ratingDataModel.careRating !== undefined && companyNameOnAgency.ratingDataModel.careRating !== null) {
                    if (companyNameOnAgency.ratingDataModel.careRating.agencyCompanyName !== undefined && companyNameOnAgency.ratingDataModel.careRating.agencyCompanyName !== null) {
                        careName = companyNameOnAgency.ratingDataModel.careRating.agencyCompanyName;
                        careDeepLink = companyNameOnAgency.ratingDataModel.careRating.deepLink;
                    }
                }

                if (companyNameOnAgency.ratingDataModel.icraRating !== undefined && companyNameOnAgency.ratingDataModel.icraRating !== null) {
                    if (companyNameOnAgency.ratingDataModel.icraRating.agencyCompanyName !== undefined && companyNameOnAgency.ratingDataModel.icraRating.agencyCompanyName !== null) {
                        icraName = companyNameOnAgency.ratingDataModel.icraRating.agencyCompanyName;
                        icraDeepLink = companyNameOnAgency.ratingDataModel.icraRating.deepLink;
                    }
                }

                if (companyNameOnAgency.ratingDataModel.acuiteRating !== undefined && companyNameOnAgency.ratingDataModel.acuiteRating !== null) {
                    if (companyNameOnAgency.ratingDataModel.acuiteRating.agencyCompanyName !== undefined && companyNameOnAgency.ratingDataModel.acuiteRating.agencyCompanyName !== null) {
                        acuiteName = companyNameOnAgency.ratingDataModel.acuiteRating.agencyCompanyName;
                        acuiteDeepLink = companyNameOnAgency.ratingDataModel.acuiteRating.deepLink;
                    }
                }

                if (companyNameOnAgency.ratingDataModel.brickworksRating !== undefined && companyNameOnAgency.ratingDataModel.brickworksRating !== null) {
                    if (companyNameOnAgency.ratingDataModel.brickworksRating.agencyCompanyName !== undefined && companyNameOnAgency.ratingDataModel.brickworksRating.agencyCompanyName !== null) {
                        brickworkName = companyNameOnAgency.ratingDataModel.brickworksRating.agencyCompanyName;
                        brickworkDeepLink = companyNameOnAgency.ratingDataModel.brickworksRating.deepLink;
                    }
                }

                if (companyNameOnAgency.ratingDataModel.irRating !== undefined && companyNameOnAgency.ratingDataModel.irRating !== null) {
                    if (companyNameOnAgency.ratingDataModel.irRating.agencyCompanyName !== undefined && companyNameOnAgency.ratingDataModel.irRating.irRating !== null) {
                        indiaratingsName = companyNameOnAgency.ratingDataModel.irRating.agencyCompanyName;
                        indiaratingsDeepLink = companyNameOnAgency.ratingDataModel.irRating.deepLink;
                    }
                }
            }
        }
    }
    requestBody = {
        acuiteAgencyCompanyName: acuiteName,
        acuiteDeepLink: acuiteDeepLink,
        brickworkAgencyCompanyName: brickworkName,
        brickworkDeepLink: brickworkDeepLink,
        careAgencyCompanyName: careName,
        careDeepLink: careDeepLink,
        crisilAgencyCompanyName: crisilName,
        crisilDeepLink: crisilDeepLink,
        icraAgencyCompanyName: icraName,
        icraDeepLink: icraDeepLink,
        irAgencyCompanyName: indiaratingsName,
        irDeepLink: indiaratingsDeepLink
    }

    return requestBody
}

export const setAgencyBody = (agencyData) => {
    let agencyBody = { shouldSearchInAcuite: false, shouldSearchInBrickwork: false, shouldSearchInCare: false, shouldSearchInCrisil: false, shouldSearchInIcra: false, shouldSearchInIR: false }
    if (agencyData.ACUITE !== undefined && agencyData.ACUITE !== null) {
        agencyBody.shouldSearchInAcuite = agencyData.ACUITE
    }
    if (agencyData.BRICKWORK !== undefined && agencyData.BRICKWORK !== null) {
        agencyBody.shouldSearchInBrickwork = agencyData.BRICKWORK
    }
    if (agencyData.CARE !== undefined && agencyData.CARE !== null) {
        agencyBody.shouldSearchInCare = agencyData.CARE
    }
    if (agencyData.CRISIL !== undefined && agencyData.CRISIL !== null) {
        agencyBody.shouldSearchInCrisil = agencyData.CRISIL
    }
    if (agencyData.ICRA !== undefined && agencyData.ICRA !== null) {
        agencyBody.shouldSearchInIcra = agencyData.ICRA
    }
    if (agencyData.INDIARATINGS !== undefined && agencyData.INDIARATINGS !== null) {
        agencyBody.shouldSearchInIR = agencyData.INDIARATINGS
    }
    return agencyBody
}

export const checkGSTNumber = (g) => {
    if(/\d{2}[A-Z]{5}\d{4}[A-Z]{1}[A-Z\d]{1}[Z]{1}[A-Z\d]{1}/.test(g)  && g.length === 15 ){
        return true
    }else{
        return false
    }
}

export const checkEmail= (g) => {
    if(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(g) ){
        return true
    }else{
        return false
    }
}

export const checkChallanVehicleNumber = (g) => {
    if(/^[A-Z0-9]+$/.test(g)){
        return true
    }else{
        return false
    }
}

export const checkTanNumber = (g) => {
    if(/[A-Z]{4}[0-9]{5}[A-Z]{1}/.test(g) && g.length === 10){
        return true
    }else{
        return false
    }
}

export const checkChasisNumber = (g) => {
    if(/^[A-Z0-9]+$/.test(g)  && g.length === 5 ){
        return true
    }else{
        return false
    }
}

export const checkEPFNumber = (epfNumbers) => {
    let epfArray = epfNumbers.split(",");
    let result = true;
    if (epfArray !== undefined) {
        for (var i = 0; i < epfArray.length; i++) {
            if (epfArray[i].length === 15) {
                if (!/[A-Z]{5}[0-9A-Z]{10}/.test(epfArray[i])) {
                    result = false
                    break
                }
            } else {
                result = false
                break
            }
        }
        return result;
    } else {
        return false
    }
}
export const checkMCANumber = (mcaNumber) => {
    if (/[U|L]{1}\d{5}[A-Z]{2}\d{4}[A-Z]{3}\d{6}/.test(mcaNumber)  && mcaNumber.length === 21) {//
        return true;
    }
    else if (/[F]{1}\d{5}/.test(mcaNumber)  && mcaNumber.length === 6) {//F12345
        return true;
    }
    else if (/[A]{1}[A-Z]{2}[-]{1}\d{4}/.test(mcaNumber) && mcaNumber.length === 8) {//AAA-2756
        return true;
    }else{
        return false;
    }
}

export const checkDINNumber = (dinNumber) => {
    const normalizedDin = Array.isArray(dinNumber) ? dinNumber[0] : dinNumber;
    return /^\d{8}$/.test(normalizedDin);
}

export const checkPANNumber = (panNumber) => {
    if(/[A-Z]{5}\d{4}[A-Z]{1}/.test(panNumber) && panNumber.length === 10){
        return true;
    }else{
        return false;
    }
}

export const checkLEINumber = (leiNumber) => {
    if(/\d{4}[0][0][0-9A-Z]{12}\d{2}/.test(leiNumber) && leiNumber.length === 20){
        return true;
    }else{
        return false;
    }
}

export const checkUdyamNumber = (udyamNumber) => {
    if(/^UDYAM-[A-Za-z]{2}-[0-9]{2}-[0-9]{7}$/.test(udyamNumber)){
        return true;
    } else{
        return false;
    }
}

export const checkUdyogNumber = (udyogNumber) => {
    if(/^[A-Za-z]{2}[0-9]{2}[a-zA-Z]{1}[0-9]{7}$/.test(udyogNumber)){
        return true;
    } else{
        return false;
    }
}

export const validateKycAutomationData=(kycAutomationDataSelected, kycCrawlerData , isRunAutomation)=>{
    let errorMessage = "";
    let flag = true;
    if (Object.keys(kycAutomationDataSelected).length === 0) {
        return false
    }
    if(kycCrawlerData.participantName && kycCrawlerData.participantName!=""){
        flag = true
    }
    else{
     flag = false
     errorMessage += "\n Please inter Participant Name"
    }
    if((kycCrawlerData.gstNo && kycCrawlerData.gstNo!="") || (kycCrawlerData.panNo && kycCrawlerData.panNo!="")){
        flag = true
    }
    else{
     flag = false
     errorMessage += "\n Please inter Gst No. or Pan No."
    }
    
    if (kycAutomationDataSelected.PAN) {
        if (checkPANNumber(kycCrawlerData.panNumber)) {
            flag = true
        } else {
            flag = false
            errorMessage = errorMessage + "\n Invalid PAN Number Format "
        }
    }
    if (kycAutomationDataSelected.GST_FILING) {
        if (checkGSTNumber(kycCrawlerData.gstNumber)) {
            flag = true;
        }
         else {
                flag = false;
                errorMessage = errorMessage + "\n Invalid GST Number Format "
        }
        if(kycCrawlerData.fy && kycCrawlerData.fy!=""){
            flag = true;
        }
        else {
            flag = false;
            errorMessage = errorMessage + "\n Invalid financial year"
    }
    }
    if (kycAutomationDataSelected.BANK) {
        if (kycCrawlerData.accountNo && kycCrawlerData.accountNo!="") {
            flag = true
        } else {
            flag = false
            errorMessage = errorMessage + "\n Invalid Bank Account Number "
        }
        if(kycCrawlerData.ifscCode && kycCrawlerData.ifscCode!=""){
            flag = true;
        }
        else {
            flag = false;
            errorMessage = errorMessage + "\n Invalid IFSC Code"
        }
    }


    if (kycAutomationDataSelected.VEHICLE_NUMBER) {
        if (kycCrawlerData.vehicleNumber && kycCrawlerData.vehicleNumber!="") {
            flag = true
        } else {
            flag = false
            errorMessage = errorMessage + "\n Invalid vehicle number "
        }
    }
    if (kycAutomationDataSelected.CHALLAN) {
        if (checkChallanVehicleNumber(kycCrawlerData.challanVehicleNumber)) {
            flag = true;
        }
        else {
                flag = false;
                errorMessage = errorMessage + "\n Invalid Vehicle Number Format For Challan"
        }
        if(checkChasisNumber(kycCrawlerData.last5DigitsOfChasisNo)){
            flag = true;
        }
        else {
            flag = false;
            errorMessage = errorMessage + "\n Invalid Chasis Number format"
        }
    }


    if (kycAutomationDataSelected.FSSAI_CERTIFICATE) {
        if (kycCrawlerData.fssaiLicenseNumber && kycCrawlerData.fssaiLicenseNumber!="") {
            flag = true
        } else {
            flag = false
            errorMessage = errorMessage + "\n Invalid FSSAI License Number "
        }
    }
    if (kycAutomationDataSelected.TAN) {
        if (checkTanNumber(kycCrawlerData.tanNumber)) {
            flag = true;
        }
        else {
                flag = false;
                errorMessage = errorMessage + "\n Invalid TAN Number Format "
        }
    }

    return errorMessage
}

export const validateAutomationData = (automationSelected, selectedData, epfData) => {
    console.log(selectedData, automationSelected);
    let errorMessage = "";
    let flag = true;
    if (Object.keys(automationSelected).length === 0) {
        return false
    }
    if (automationSelected.LEI) {
        console.log(selectedData.LEI)
        if (checkLEINumber(selectedData.LEI)) {
            flag = true;
        } else {
            if (selectedData.LEI) {
                flag = true;
            } else {
                flag = false;
                errorMessage = errorMessage + "\n Invalid LEI Number Format "
            }
        }
    }
    if (automationSelected.GST) {
        if (checkGSTNumber(selectedData.gstNo)) {
            flag = true;
        } else {
            if (selectedData.panNo) {
                flag = true;
            } else {
                flag = false;
                errorMessage = errorMessage + "\n Invalid GST Number Format "
            }
        }
    }
    if (automationSelected.PAN) {
        if(selectedData.PAN === undefined){
            selectedData.PAN = selectedData.panNo
        }
        if (checkPANNumber(selectedData.PAN)) {
            flag = true
        } else {
            flag = false
            errorMessage = errorMessage + "\n Invalid PAN Number Format "
        }
    }
    if (automationSelected.MCA) {
        if(selectedData.MCA === undefined){
            selectedData.MCA = selectedData.cinNumber
        }
        if (checkMCANumber(selectedData.MCA)) {
            flag = true
        } else {
            flag = false
            errorMessage = errorMessage + "\n Invalid CIN Number Format "
        }
    }
    if (automationSelected.DIN) {
        if (selectedData.DIN === undefined) {
            selectedData.DIN = selectedData.dinNumber
        }
        if (checkDINNumber(selectedData.DIN)) {
            flag = true
        } else {
            flag = false
            errorMessage = errorMessage + "\n Invalid DIN Number Format "
        }
    }
    if (automationSelected.EPF) {
        if (selectedData.EPF) {
            if(!checkEPFNumber(selectedData.EPF)){
                flag = false
                errorMessage = errorMessage + "\n Invalid PF Number Format "
            }
            
        } 
        else if(selectedData.EPF !== undefined && selectedData.EPF.length === 0){
            flag = false
            errorMessage = errorMessage + "\n Invalid PF Number Format "
        }
        else {
            if (epfData.length > 0) {
                if (checkEPFNumber(epfData.toString().replaceAll(' ',''))) {
                    selectedData.EPF = epfData.toString().replaceAll(' ','')
                } else {
                    flag = false
                    errorMessage = errorMessage + "\n Invalid PF Number Format "
                }
            } else {
                flag = false
                errorMessage = errorMessage + "\n Invalid PF Number Format "
            }
        }
    }
    if (automationSelected.RATINGS) {
        if(!selectedData.ratingsSearchType){
            flag = false;
            errorMessage = errorMessage + "\n Select CIN or PAN for rating search"
        }else{
            if(selectedData.ratingsSearchType === CIN && checkMCANumber(selectedData.RATINGS)){
               flag = true
            }
            else if(selectedData.ratingsSearchType === PAN && checkPANNumber(selectedData.RATINGS)){
                flag = true;
            }else{
                flag = false;
                errorMessage = errorMessage + "\n Invalid CIN or PAN"
            }
        }
    }
    ///bse NSE
    if (automationSelected.STOCK_EXCHANGE) {
        if(!selectedData.stockType){
            flag = false;
            errorMessage = errorMessage + "\n Select BSE or NSE for Stock Exchange"
        }else{
            if(selectedData.stockType.includes(BSE) || selectedData.stockType.includes(NSE)){
               flag = true
            }else{
                flag = false;
                errorMessage = errorMessage + "\n Invalid Company ID"
            }
        }
    }
    //end-
    if (automationSelected.LEGAL) {
        if (selectedData.LEGAL && selectedData.LEGAL_name && selectedData.LEGAL_name.trim().length > 2 && selectedData.legalMatchType) {
            flag = true
        } else {
            flag = false
            errorMessage =  "Enter Required Data "
        }
    }
    if (automationSelected.INTERNATIONAL) {
        if (selectedData.INTERNATIONAL && selectedData.INTERNATIONAL !== "") {
            flag = true
        } else {
            flag = false
            errorMessage =  "Enter Required Data "
        }
    }
    if (automationSelected.SOCIALMEDIA) {
        if (selectedData.socialMediaName && selectedData.socialMediaName != ""){
            flag = true
        } else {
            flag = false
            errorMessage = "Valid Company Name Required "
        }

        if (selectedData.socialMediaAddress && selectedData.socialMediaAddress != ""){
            flag = true
        } else {
            flag = false
            errorMessage = "Valid Company Address Required "
        }
    }
    if (automationSelected.LEI) {
        if (selectedData.LEI === undefined){
            selectedData.LEI = selectedData.cinNumber
        }

        if (selectedData.LEI && selectedData.leiSearchType) {
            if (selectedData.leiSearchType == CIN && checkMCANumber(selectedData.LEI)) {
                flag = true
            } 
            else if (selectedData.leiSearchType == NAME && selectedData.LEI != "" && selectedData.LEI.trim().length > 2 && !checkMCANumber(selectedData.LEI)) {
                    flag = true
            } 
            else if (selectedData.leiSearchType == GST && checkGSTNumber(selectedData.LEI)) {
                flag = true
            }
            else if (selectedData.leiSearchType == PAN && checkPANNumber(selectedData.LEI)) {
                flag = true
            }
            else if (selectedData.leiSearchType == LEI && checkLEINumber(selectedData.LEI)) {
                flag = true
            }
            else {
                    flag = false
                    errorMessage = " Please Enter Valid Input "
                }

        } else {
            flag = false
            errorMessage = " Please Enter / Select Required Data "
        }
        
    }
    if (automationSelected.IEC) {
        if (selectedData.iecIdentifier && selectedData.iecIdentifier != ""){
            flag = true
        } else {
            flag = false
            errorMessage = "Valid IEC / PAN Required "
        }
        if (selectedData.iecCompanyName && selectedData.iecCompanyName != ""){
            flag = true
        } else {
            flag = false
            errorMessage = "Valid Company Name Required IEC"
        }
    }
    if (automationSelected.UDYAM) {
        if (selectedData.udyamIdentifier && checkUdyamNumber(selectedData.udyamIdentifier)){
            flag = true;
        } else {
            flag = false;
            errorMessage = "Valid Udyam Number Required "
        }
    }
    if (automationSelected.UDYOG) {
        if (selectedData.udyogIdentifier && checkUdyogNumber(selectedData.udyogIdentifier)){
            flag = true;
        } else {
            flag = false;
            errorMessage = "Valid Udyog Number Required "
        }
    }

    if (automationSelected.NICCODE_SEARCH) {
        if (selectedData.nicCode && selectedData.nicCode.length === 5) {
            flag = true;
        } else {
            flag = false;
            errorMessage = "Valid Nic Code Required "
        }
    }

    if (automationSelected.GST_ANALYSIS) {
        if(selectedData.GST_ANALYSIS === undefined){
            selectedData.GST_ANALYSIS = selectedData.gstNo
        }
        if(!selectedData[GST_ANALYSIS_NOT_REQUIRED_FIELDS.phoneNo]) {
            selectedData[GST_ANALYSIS_NOT_REQUIRED_FIELDS.phoneNo] = selectedData.counterpartyPhone
        }
        for (let property in GST_ANALYSIS_REQUIRED_FIELDS) {
            if(selectedData[GST_ANALYSIS_REQUIRED_FIELDS[property]]) {
                flag = true
            }
            else {
                flag = false
                errorMessage = errorMessage + "\n Please fill all the required fields "
                break;
            }
        }
        if(flag) {
            if (checkGSTNumber(selectedData.GST_ANALYSIS)) {
                flag = true
            } else {
                flag = false
                errorMessage = errorMessage + "\n Invalid GST Number Format "
            }
        }
    }
    if (automationSelected.BANK_STATEMENT_ANALYSIS) {
        for (let property in BANK_STATEMENT_ANALYSIS_REQUIRED_FIELDS) {
            if(selectedData[BANK_STATEMENT_ANALYSIS_REQUIRED_FIELDS[property]]) {
                flag = true
            }
            else {
                flag = false
                errorMessage = errorMessage + "\n Please fill all the required fields "
                break;
            }
        }
        if(selectedData[BANK_STATEMENT_ANALYSIS_REQUIRED_FIELDS.bsaAccountType] && 
            (selectedData[BANK_STATEMENT_ANALYSIS_REQUIRED_FIELDS.bsaAccountType] === "CASH_CREDIT" || 
                selectedData[BANK_STATEMENT_ANALYSIS_REQUIRED_FIELDS.bsaAccountType] === "OVER_DRAFT") &&
                !selectedData[BANK_STATEMENT_ANALYSIS_NOT_REQUIRED_FIELDS.bsaSanctionLimit]) {
            flag = false
            errorMessage = errorMessage + "\n Please fill the sanction limit "
        }
    }  
    
    if (automationSelected.ITR_ANALYSIS) {

        if (checkEmail(selectedData['email'])) {
            flag = true
        } else {
            flag = false
            errorMessage = errorMessage + "\n Please provide a valid emailId "
        }
    }

    if (automationSelected.EMAIL) {
        if (!selectedData.emailId || (selectedData.emailId && selectedData.emailId === '') || checkEmail(selectedData['email'])) {
            errorMessage += "\n Please enter a valid emailId";
        }
    }

   if (automationSelected.RETAIL_BUREAU) {
        if (selectedData.retailBureauRequestType && selectedData.retailBureauRequestType != ""){
            if(selectedData.retailBureauRequestType==="OTP" && selectedData.mobileNo && selectedData.mobileNo!="" ||
               selectedData.retailBureauRequestType==="EMAIL" && selectedData.emailId && selectedData.emailId!=""){
                flag = true
            }
            else{
                flag = false
                errorMessage + "\n MobileNo is required field for Otp and Email is required field for Email"
            }
            if( selectedData.firstName && selectedData.firstName!='' && selectedData.identity && selectedData.identity!=''){
                flag = true
            }
            else{
                flag = false
                errorMessage = errorMessage + "\n Please fill all fields of Retail Bureau"
            }
        } else {
            flag = false
            errorMessage = errorMessage + "\n please select OTP or EMAIL for Retail Bureau"
        }
    }

    if (automationSelected.ZIGRAM) {
        if(!selectedData.reportType){
            flag = false;
            errorMessage = errorMessage + "\n Select INDIVIDUAL or ORGANISATION"
        }else{
            if(selectedData.reportType.includes(INDIVIDUAL) || selectedData.reportType.includes(ORGANIZATION)){
               flag = true
            }else{
                flag = false;
                errorMessage = errorMessage + "\n Select INDIVIDUAL or ORGANISATION"
            }
        }
        if (selectedData.counterpartyName && selectedData.counterpartyName != ""){
            flag = true
        } else {
            flag = false
            errorMessage = "Valid Company Name Required"
        }
    }

    return errorMessage
}

export const updateCrawlerStatusinCaseData = (caseData, crawlerStatusData) => {
    /* caseData.caseViewList.forEach(cases => {
        crawlerStatusData.forEach(status => {
            if (cases.counterpartyId === status.counterpartyId) {
                cases.crawlerStatus = status.crawlerStatus
            }
        })
    }) */
    return caseData;
}

export const getfinalCrawlerStatus = (crawlerData) => {
    let inprogressCount = 0, failedCount = 0, successCount = 0, partialFailedCount = 0;;
    for (let i = 0; i < crawlerData.length; i++) {
        if (crawlerData[i].crawlerStatus === 'INPROGRESS') {
            inprogressCount = inprogressCount + 1
        } else if (crawlerData[i].crawlerStatus === 'FAILURE') {
            failedCount = failedCount + 1;
        } else if (crawlerData[i].crawlerStatus === 'SUCCESS') {
            successCount = successCount + 1;
        } else if (crawlerData[i].crawlerStatus === 'PARTIAL_FAILURE') {
            partialFailedCount = partialFailedCount + 1;
        }
    }
    if (inprogressCount > 0) {
        return "INPROGRESS";
    } else if (failedCount > 0) {
        return "FAILURE";
    } else if (partialFailedCount > 0) {
        return "PARTIAL_FAILURE";
    } else if (successCount > 0) {
        return "SUCCESS";
    } else {
        return "START"
    }
}

export const getCrawlerStatusType = (crawlerStatus) => {
    if (crawlerStatus === "SUCCESS") {
        return "crawler-success"
    } else if (crawlerStatus === "INPROGRESS") {
        return "crawler-inprogress"
    } else if (crawlerStatus === "FAILURE") {
        return "crawler-failed"
    } else {
        return "crawler-nostatus";
    }
}


export const isLegalCrawlerSucceed = (crawlerData, corporateId) => {
    for (let i = 0; i < crawlerData.length; i++) {
        if (crawlerData[i].crawlerStatus === "SUCCESS" && crawlerData[i].crawlerName === "LEGAL" && crawlerData[i].corporateId === corporateId) {
            return ({ counterpartyId: crawlerData[i].counterpartyId, isLegalCrawlerSucceed: true, name: crawlerData[i].counterpartyName, corporateId: crawlerData[i].corporateId, legalModerationStatus: crawlerData[i].legalModerationStatus });
        }
    }
    return ({ isLegalCrawlerSucceed: false })
}

export const isAdditionalLegalCrawlerSucceed = (crawlerData, corporateId) => {
    for (let i = 0; i < crawlerData.length; i++) {
        if (crawlerData[i].crawlerStatus === "SUCCESS" && crawlerData[i].crawlerName === "ADDITIONAL_LEGAL" && crawlerData[i].corporateId === corporateId) {
            return ({ counterpartyId: crawlerData[i].counterpartyId, isAdditionalLegalCrawlerSucceed: true, name: crawlerData[i].counterpartyName, corporateId: crawlerData[i].corporateId, legalModerationStatus: crawlerData[i].legalModerationStatus });
        }
    }
    return ({ isAdditionalLegalCrawlerSucceed: false })
}

export const isNewsCrawlerSucceed = (crawlerData, corporateId) => {
    for (let i = 0; i < crawlerData.length; i++) {
        if (crawlerData[i].crawlerStatus === "SUCCESS" && crawlerData[i].crawlerName === "NEWS" && crawlerData[i].corporateId === corporateId) {
            return ({ counterpartyId: crawlerData[i].counterpartyId, isNewsCrawlerSucceed: true, name: crawlerData[i].counterpartyName, corporateId: crawlerData[i].corporateId, newsModerationStatus: crawlerData[i].newsModerationStatus });
        }
    }
    return ({ isNewsCrawlerSucceed: false })
}

export const checkForModeration = (crawlerData, corporateId) => {
    for (let i = 0; i < crawlerData.length; i++) {
        if (crawlerData[i].crawlerStatus === "SUCCESS" && crawlerData[i].crawlerName === "LEGAL" && crawlerData[i].corporateId === corporateId) {
            return (true);
        }
        if (crawlerData[i].crawlerStatus === "SUCCESS" && crawlerData[i].crawlerName === "ADDITIONAL_LEGAL" && crawlerData[i].corporateId === corporateId) {
            return (true);
        }
        if (crawlerData[i].crawlerStatus === "SUCCESS" && crawlerData[i].crawlerName === "NEWS" && crawlerData[i].corporateId === corporateId) {
            return (true);
        }
    }
    return (false)
}

export const isCrawlerInInprogressState = (crawlerData, corporateId) => {
    for (let i = 0; i < crawlerData.length; i++) {
        if (crawlerData[i].crawlerStatus === "INPROGRESS" && crawlerData[i].corporateId === corporateId) {
            return true;
        }
    }
    return false;
}

export const additionalFieldsExtract = (caseData) => {
    let additionalFields = {
        caseId: caseData.caseId,
        enquiryReferenceNumber: caseData.enquiryReferenceNumber,
        buyerCode: caseData.buyerCode,
        indianPartyName: caseData.indianPartyName,
        counterpartyContactDetails: caseData.counterpartyContactDetails,
        counterpartyWebsite: caseData.counterpartyWebsite,
        counterpartyEmail: caseData.counterpartyEmail,
        otherEnquiryDetails: caseData.otherEnquiryDetails,
        discloseCorporate: caseData.discloseCorporate
    }
    return additionalFields;
}

export const dbiAdapter = (caseId, counterpartyId, xmlDoc) => {
    commonJson['caseId'] = caseId;
    commonJson['counterpartyId'] = counterpartyId;

    //-----Enquiry Details-----
    if (xmlDoc.getElementsByTagName("Identification").length > 0) {
        if (xmlDoc.getElementsByTagName("Identification")[0].getElementsByTagName("Given").length > 0) {
            if (!(xmlDoc.getElementsByTagName("Identification")[0].getElementsByTagName("Given")[0].getElementsByTagName("SubjectName")[0] === undefined || xmlDoc.getElementsByTagName("Identification")[0].getElementsByTagName("Given")[0].getElementsByTagName("SubjectName")[0] === null)) {
                commonJson['name_of_Entity_Enquiry_Details_International'] = xmlDoc.getElementsByTagName("Identification")[0].getElementsByTagName("Given")[0].getElementsByTagName("SubjectName")[0].textContent;
            }

            if (!(xmlDoc.getElementsByTagName("Identification")[0].getElementsByTagName("Given")[0].getElementsByTagName("GivenAddress")[0] === undefined || xmlDoc.getElementsByTagName("Identification")[0].getElementsByTagName("Given")[0].getElementsByTagName("GivenAddress")[0] === null)) {
                commonJson['address_of_Entity_Enquiry_Details_International'] = xmlDoc.getElementsByTagName("Identification")[0].getElementsByTagName("Given")[0].getElementsByTagName("GivenAddress")[0].getElementsByTagName("Street")[0].textContent;
            }

            if (!(xmlDoc.getElementsByTagName("Identification")[0].getElementsByTagName("Given")[0].getElementsByTagName("GivenAddress")[0].getElementsByTagName("Country")[0].getElementsByTagName('CountryName')[0] === undefined || xmlDoc.getElementsByTagName("Identification")[0].getElementsByTagName("Given")[0].getElementsByTagName("GivenAddress")[0].getElementsByTagName("Country")[0].getElementsByTagName('CountryName')[0] === null)) {
                commonJson['country_Enquiry_Details_International'] = xmlDoc.getElementsByTagName("Identification")[0].getElementsByTagName("Given")[0].getElementsByTagName("GivenAddress")[0].getElementsByTagName("Country")[0].getElementsByTagName('CountryName')[0].textContent;
            }

            if (!(xmlDoc.getElementsByTagName("Identification")[0].getElementsByTagName("Given")[0].getElementsByTagName("Telephone")[0] === undefined || xmlDoc.getElementsByTagName("Identification")[0].getElementsByTagName("Given")[0].getElementsByTagName("Telephone")[0] === null)) {
                commonJson['telephone_Number_Enquiry_Details_International'] = (xmlDoc.getElementsByTagName("Identification")[0].getElementsByTagName("Given")[0].getElementsByTagName("Telephone")[0].textContent);
            }

            if (!(xmlDoc.getElementsByTagName("Identification")[0].getElementsByTagName("Given")[0].getElementsByTagName("Email")[0] === undefined || xmlDoc.getElementsByTagName("Identification")[0].getElementsByTagName("Given")[0].getElementsByTagName("Email")[0] === null)) {

                commonJson['email_ID_Enquiry_Details_International'] = xmlDoc.getElementsByTagName("Identification")[0].getElementsByTagName("Given")[0].getElementsByTagName("Email")[0].textContent;
            }

            if (!(xmlDoc.getElementsByTagName("Identification")[0].getElementsByTagName("Given")[0].getElementsByTagName("Website")[0] === undefined || xmlDoc.getElementsByTagName("Identification")[0].getElementsByTagName("Given")[0].getElementsByTagName("Website")[0] === null)) {
                commonJson['website_Enquiry_Details_International'] = xmlDoc.getElementsByTagName("Identification")[0].getElementsByTagName("Given")[0].getElementsByTagName("Website")[0].textContent;
            }
        }

        if (xmlDoc.getElementsByTagName("Identification")[0].getElementsByTagName("Verified").length > 0) {
            if (!(xmlDoc.getElementsByTagName("Identification")[0].getElementsByTagName("Verified")[0].getElementsByTagName("Website")[0] === undefined || xmlDoc.getElementsByTagName("Identification")[0].getElementsByTagName("Verified")[0].getElementsByTagName("Website")[0] === undefined)) {
                commonJson['website_Investigated_Details_International'] = xmlDoc.getElementsByTagName("Identification")[0].getElementsByTagName("Verified")[0].getElementsByTagName("Website")[0].textContent;
            }

            if (!(xmlDoc.getElementsByTagName("Identification")[0].getElementsByTagName("Verified")[0].getElementsByTagName("Email")[0] === undefined || xmlDoc.getElementsByTagName("Identification")[0].getElementsByTagName("Verified")[0].getElementsByTagName("Email")[0] === null)) {
                commonJson['email_ID_Investigated_Details_International'] = xmlDoc.getElementsByTagName("Identification")[0].getElementsByTagName("Verified")[0].getElementsByTagName("Email")[0].textContent;
            }

            if (!(xmlDoc.getElementsByTagName("Identification")[0].getElementsByTagName("Verified")[0].getElementsByTagName("EnglishName")[0] === undefined || xmlDoc.getElementsByTagName("Identification")[0].getElementsByTagName("Verified")[0].getElementsByTagName("EnglishName")[0] === null)) {
                commonJson["name_International"] = xmlDoc.getElementsByTagName("Identification")[0].getElementsByTagName("Verified")[0].getElementsByTagName("EnglishName")[0].textContent;
            }

            if (!(xmlDoc.getElementsByTagName("Identification")[0].getElementsByTagName("Verified")[0].getElementsByTagName("OtherStyle")[0] === undefined || xmlDoc.getElementsByTagName("Identification")[0].getElementsByTagName("Verified")[0].getElementsByTagName("OtherStyle")[0] === null)) {
                commonJson["trading_Name_International"] = xmlDoc.getElementsByTagName("Identification")[0].getElementsByTagName("Verified")[0].getElementsByTagName("OtherStyle")[0].textContent;
            }

            if (!(xmlDoc.getElementsByTagName("Identification")[0].getElementsByTagName("Verified")[0].getElementsByTagName("EnglishName")[0] === undefined || xmlDoc.getElementsByTagName("Identification")[0].getElementsByTagName("Verified")[0].getElementsByTagName("EnglishName")[0] === null)) {
                commonJson['name_of_Entity_Investigated_Details_International'] = xmlDoc.getElementsByTagName("Identification")[0].getElementsByTagName("Verified")[0].getElementsByTagName("EnglishName")[0].textContent;
            }

            let verifiedAddress = ""
            let verifiedCountry = ""
            for (var i = 0; i < xmlDoc.getElementsByTagName("Identification")[0].getElementsByTagName("Verified")[0].getElementsByTagName("Addresses")[0].getElementsByTagName("Address").length; i++) {

                let key = xmlDoc.getElementsByTagName("Identification")[0].getElementsByTagName("Verified")[0].getElementsByTagName("Addresses")[0].getElementsByTagName("Address")[i];
                if (!(key.getElementsByTagName('Street')[0] === undefined || key.getElementsByTagName('Street')[0] === null)) {
                    verifiedAddress = verifiedAddress.concat(key.getElementsByTagName('Street')[0].textContent, " ")
                }
                if (!(key.getElementsByTagName('Town')[0] === undefined || key.getElementsByTagName('Town')[0] === null)) {
                    verifiedAddress = verifiedAddress.concat(key.getElementsByTagName('Town')[0].textContent, " ")
                }
                if (!(key.getElementsByTagName('Zipcode')[0] === undefined || key.getElementsByTagName('Zipcode')[0] === null)) {
                    verifiedAddress = verifiedAddress.concat(key.getElementsByTagName('Zipcode')[0].textContent)
                }
                if (!(key.getElementsByTagName('Country')[0] === undefined || key.getElementsByTagName('Country')[0] === null)) {
                    verifiedCountry = key.getElementsByTagName('Country')[0].getElementsByTagName('CountryName')[0].textContent
                }
            }
            commonJson['address_of_Entity_Investigated_Details_International'] = verifiedAddress;
            commonJson['country_Investigated_Details_International'] = verifiedCountry;



            let verifiedTelephone = ""
            if (!(xmlDoc.getElementsByTagName("Identification")[0].getElementsByTagName("Verified")[0].getElementsByTagName("Telephone")[0] === undefined || xmlDoc.getElementsByTagName("Identification")[0].getElementsByTagName("Verified")[0].getElementsByTagName("Telephone")[0] === null)) {
                //console.log("-----Undefine-----")
                verifiedTelephone = verifiedTelephone.concat(xmlDoc.getElementsByTagName("Identification")[0].getElementsByTagName("Verified")[0].getElementsByTagName("Telephone")[0].getElementsByTagName("Number")[0].textContent, " ")
            }
            if (!(xmlDoc.getElementsByTagName("Identification")[0].getElementsByTagName("Verified")[0].getElementsByTagName("Mobile")[0] === undefined || xmlDoc.getElementsByTagName("Identification")[0].getElementsByTagName("Verified")[0].getElementsByTagName("Mobile")[0] === null)) {
                verifiedTelephone = verifiedTelephone.concat(xmlDoc.getElementsByTagName("Identification")[0].getElementsByTagName("Verified")[0].getElementsByTagName("Mobile")[0].textContent)
            }
            commonJson['telephone_Number_Investigated_Details_International'] = verifiedTelephone;

            //---------Loactions----------------
            var locations = xmlDoc.getElementsByTagName("Identification")[0].getElementsByTagName("Verified")[0].getElementsByTagName("Addresses")[0];
            if (!(locations === undefined || locations === null)) {
                for (var i = 0; i < locations.getElementsByTagName("Address").length; i++) {

                    let key = locations.getElementsByTagName("Address")[i];
                    let address = "";
                    if (!(key.getElementsByTagName('Street')[0] === undefined || key.getElementsByTagName('Street')[0] === null)) {
                        address = address.concat(key.getElementsByTagName('Street')[0].textContent, " ")
                    }
                    if (!(key.getElementsByTagName('Town')[0] === undefined || key.getElementsByTagName('Town')[0] === null)) {
                        address = address.concat(key.getElementsByTagName('Town')[0].textContent, " ")
                    }
                    if (!(key.getElementsByTagName('Zipcode')[0] === undefined || key.getElementsByTagName('Zipcode')[0] === null)) {
                        address = address.concat(" ", key.getElementsByTagName('Zipcode')[0].textContent);
                    }
                    commonJson["locations_international_address"].push(address);
                    commonJson["locations_international_type"].push("");
                    commonJson["locations_international_size"].push("NA");
                    commonJson["locations_international_rental_owned"].push("NA");
                    commonJson["locations_international_lease_tenure"].push("NA");
                    commonJson["locations_international_comments"].push("NA");

                }
            }
        }
    }

    if (xmlDoc.getElementsByTagName("Reference").length > 0) {
        if (!(xmlDoc.getElementsByTagName("Reference")[0].getElementsByTagName("CustomerRef1")[0] === undefined || xmlDoc.getElementsByTagName("Reference")[0].getElementsByTagName("CustomerRef1")[0] === null)) {
            commonJson['buyer_Code_Enquiry_Details_International'] = xmlDoc.getElementsByTagName("Reference")[0].getElementsByTagName("CustomerRef1")[0].textContent;
        }
        if (!(xmlDoc.getElementsByTagName("Reference")[0].getElementsByTagName("CustomerRef1")[0] === undefined || xmlDoc.getElementsByTagName("Reference")[0].getElementsByTagName("CustomerRef1")[0] === null)) {
            commonJson['buyer_Code_Investigated_Details_International'] = xmlDoc.getElementsByTagName("Reference")[0].getElementsByTagName("CustomerRef1")[0].textContent;
        }
    }

    if (xmlDoc.getElementsByTagName("RegistryData").length > 0) {
        if (!(xmlDoc.getElementsByTagName("RegistryData")[0].getElementsByTagName("PreviousName")[0] === undefined || xmlDoc.getElementsByTagName("RegistryData")[0].getElementsByTagName("PreviousName")[0] === null)) {
            commonJson["former_Name_International"] = xmlDoc.getElementsByTagName("RegistryData")[0].getElementsByTagName("PreviousName")[0].textContent;
        }
        else {
            commonJson["former_Name_International"] = "NA"
        }

        if (!(xmlDoc.getElementsByTagName("RegistryData")[0].getElementsByTagName("LegalForm")[0] === undefined || xmlDoc.getElementsByTagName("RegistryData")[0].getElementsByTagName("LegalForm")[0] === null)) {
            commonJson["type_of_Company_International"] = xmlDoc.getElementsByTagName("RegistryData")[0].getElementsByTagName("LegalForm")[0].textContent;
        }

        if (!(xmlDoc.getElementsByTagName("RegistryData")[0].getElementsByTagName("DateRegistered")[0] === undefined || xmlDoc.getElementsByTagName("RegistryData")[0].getElementsByTagName("DateRegistered")[0] === null)) {
            commonJson["year_Established_International"] = xmlDoc.getElementsByTagName("RegistryData")[0].getElementsByTagName("DateRegistered")[0].getElementsByTagName("DateStr")[0].textContent;
        }

        if (!(xmlDoc.getElementsByTagName("RegistryData")[0].getElementsByTagName("RegistryStatus")[0] === undefined || xmlDoc.getElementsByTagName("RegistryData")[0].getElementsByTagName("RegistryStatus")[0] === null)) {
            commonJson["company_Status_International"] = xmlDoc.getElementsByTagName("RegistryData")[0].getElementsByTagName("RegistryStatus")[0].textContent;
        }

        if (!(xmlDoc.getElementsByTagName("RegistryData")[0].getElementsByTagName("RegistryNumbers")[0] === undefined || xmlDoc.getElementsByTagName("RegistryData")[0].getElementsByTagName("RegistryNumbers")[0] === null)) {
            let otherIdentifiers = "";
            let registerNumber = "";
            for (var i = 0; i < xmlDoc.getElementsByTagName("RegistryData")[0].getElementsByTagName("RegistryNumbers")[0].getElementsByTagName("RegistryNumber").length; i++) {
                let key = xmlDoc.getElementsByTagName("RegistryData")[0].getElementsByTagName("RegistryNumbers")[0].getElementsByTagName("RegistryNumber")[i];
                // console.log(key.attributes["registrynumbertype"].value);
                // console.log(key.getElementsByTagName("Number"))
                if (key.attributes["registrynumbertype"].value === "RegistrationNumber") {
                    if (!(key.getElementsByTagName("Number")[0] === undefined || key.getElementsByTagName("Number")[0] === null)) {
                        registerNumber = key.getElementsByTagName("Number")[0].textContent.concat("\\nRegistration Authority: ", !(key.getElementsByTagName("RegistryAuthority")[0] === undefined || key.getElementsByTagName("RegistryAuthority")[0] === null) ? key.getElementsByTagName("RegistryAuthority")[0].textContent : "").concat("\\n")
                    }
                }
                else {
                    otherIdentifiers = otherIdentifiers.concat(!(key.getElementsByTagName("Name")[0] === undefined || key.getElementsByTagName("Name")[0] === null) ? key.getElementsByTagName("Name")[0].textContent : "").concat(!(key.getElementsByTagName("Number")[0] === undefined || key.getElementsByTagName("Number")[0] === null) ? key.getElementsByTagName("Number")[0].textContent : "", "\\n").concat("Registration Authority: ", !(key.getElementsByTagName("RegistryAuthority")[0] === undefined || key.getElementsByTagName("RegistryAuthority")[0] === null) ? key.getElementsByTagName("RegistryAuthority")[0].textContent : "")
                }

            }
            commonJson['registration_Number_International'] = registerNumber;
            commonJson['other_Identifiers_International'] = otherIdentifiers;

        }
        //----History of name change

        if (!(xmlDoc.getElementsByTagName("RegistryData")[0].getElementsByTagName("PreviousName")[0] === undefined || xmlDoc.getElementsByTagName("RegistryData")[0].getElementsByTagName("PreviousName")[0] === null)) {
            commonJson["history_of_Names_Name_Change_of_the_Business_Entity_International"] = xmlDoc.getElementsByTagName("RegistryData")[0].getElementsByTagName("PreviousName")[0].textContent;
        }
    }

    if (xmlDoc.getElementsByTagName("ManagementAndStaff").length > 0) {
        if (xmlDoc.getElementsByTagName("ManagementAndStaff")[0].getElementsByTagName("Staff").length > 0) {
            if (!(xmlDoc.getElementsByTagName("ManagementAndStaff")[0].getElementsByTagName("Staff")[0].getElementsByTagName("SubjectNoOfEmployees")[0] === undefined || xmlDoc.getElementsByTagName("ManagementAndStaff")[0].getElementsByTagName("Staff")[0].getElementsByTagName("SubjectNoOfEmployees")[0] === null)) {
                commonJson["employee_Size_International"] = xmlDoc.getElementsByTagName("ManagementAndStaff")[0].getElementsByTagName("Staff")[0].getElementsByTagName("SubjectNoOfEmployees")[0].textContent;
            }
        }
    }

    //-------line of business-----------
    if (xmlDoc.getElementsByTagName("OperationAndHistory").length > 0) {
        if (xmlDoc.getElementsByTagName("OperationAndHistory")[0].getElementsByTagName("Activities").length > 0) {
            let linebusinessData = ""
            if (!(xmlDoc.getElementsByTagName("OperationAndHistory")[0].getElementsByTagName("Activities")[0].getElementsByTagName("FullDescription")[0] === undefined || xmlDoc.getElementsByTagName("OperationAndHistory")[0].getElementsByTagName("Activities")[0].getElementsByTagName("FullDescription")[0] === null)) {
                linebusinessData = linebusinessData.concat(xmlDoc.getElementsByTagName("OperationAndHistory")[0].getElementsByTagName("Activities")[0].getElementsByTagName("FullDescription")[0].textContent, " \\n\\n")
            }
            if (!(xmlDoc.getElementsByTagName("OperationAndHistory")[0].getElementsByTagName("Activities")[0].getElementsByTagName("ProductsAndServices")[0] === undefined || xmlDoc.getElementsByTagName("OperationAndHistory")[0].getElementsByTagName("Activities")[0].getElementsByTagName("ProductsAndServices")[0] === null)) {
                linebusinessData = linebusinessData.concat(xmlDoc.getElementsByTagName("OperationAndHistory")[0].getElementsByTagName("Activities")[0].getElementsByTagName("ProductsAndServices")[0].textContent)
            }
            commonJson["line_of_Business_International"] = linebusinessData;
        }
    }
    //-----Share holdiong
    if (xmlDoc.getElementsByTagName("ShareholdersAndOwners").length > 0) {
        var shareholder = xmlDoc.getElementsByTagName("ShareholdersAndOwners")[0].getElementsByTagName("Shareholders")[0];
        if (!(shareholder === undefined || shareholder === null)) {
            for (var i = 0; i < shareholder.getElementsByTagName("ShareholderItem").length; i++) {

                let key = shareholder.getElementsByTagName("ShareholderItem")[i];
                if (!(key.getElementsByTagName('Name')[0] === undefined || key.getElementsByTagName('Name')[0] === null)) {
                    commonJson['shareholding_international_shareholder_name'].push(key.getElementsByTagName('Name')[0].textContent);
                }
                else {
                    commonJson['shareholding_international_shareholder_name'].push("NA")
                }
                if (!(key.getElementsByTagName('ShareholderShareClassItem')[0].getElementsByTagName('Percentage')[0] === undefined || key.getElementsByTagName('ShareholderShareClassItem')[0].getElementsByTagName('Percentage')[0] === null)) {
                    commonJson['shareholding_international_shareholding'].push(key.getElementsByTagName('ShareholderShareClassItem')[0].getElementsByTagName('Percentage')[0].textContent);
                }
                else {
                    commonJson['shareholding_international_shareholding'].push("NA")
                }
                if (!(key.getElementsByTagName('Country')[0] === undefined || key.getElementsByTagName('Country')[0] === null)) {
                    commonJson['shareholding_international_nationality'].push(key.getElementsByTagName('Country')[0].getElementsByTagName('CountryName')[0].textContent);
                }
                else {
                    commonJson['shareholding_international_nationality'].push("NA")
                }
            }
        }
    }

    //---------------managementStaff-----------------
    if (xmlDoc.getElementsByTagName("BoardOfDirectors").length > 0) {
        var managementPromoterDirectors = xmlDoc.getElementsByTagName("BoardOfDirectors")[0];
        if (!(managementPromoterDirectors === undefined || managementPromoterDirectors === null)) {
            for (var i = 0; i < managementPromoterDirectors.getElementsByTagName("Appointment").length; i++) {

                let key = managementPromoterDirectors.getElementsByTagName("Appointment")[i];
                if (!(key.getElementsByTagName('Name')[0] === undefined || key.getElementsByTagName('Name')[0] === null)) {
                    commonJson['management_international_name'].push(key.getElementsByTagName('Name')[0].textContent);
                }
                else {
                    commonJson['management_international_name'].push("NA")
                }
                if (key.getElementsByTagName('BoardFunctions').length > 0) {
                    if (!(key.getElementsByTagName('BoardFunctions')[0].getElementsByTagName('BoardFunction')[0] === undefined || key.getElementsByTagName('BoardFunctions')[0].getElementsByTagName('BoardFunction')[0] === null)) {
                        commonJson['management_international_designation'].push(key.getElementsByTagName('BoardFunctions')[0].getElementsByTagName('BoardFunction')[0].textContent);
                    }
                    else {
                        commonJson['management_international_designation'].push("NA")
                    }
                }
                else {
                    commonJson['management_international_designation'].push("NA")
                }
                if (key.getElementsByTagName('Country').length > 0) {
                    if (!(key.getElementsByTagName('Country')[0].getElementsByTagName('CountryName')[0] === undefined || key.getElementsByTagName('Country')[0].getElementsByTagName('CountryName')[0] === null)) {
                        commonJson['management_international_nationality'].push(key.getElementsByTagName('Country')[0].getElementsByTagName('CountryName')[0].textContent);
                    }
                    else {
                        commonJson['management_international_nationality'].push("NA")
                    }
                }
                else {
                    commonJson['management_international_nationality'].push("NA")
                }
                commonJson['management_international_age'].push("NA");
                commonJson['management_international_qualification'].push("NA");
                commonJson['management_international_experience'].push("NA");
                let managementComment = "";
                if (!(key.getElementsByTagName('IDNumber')[0] === undefined || key.getElementsByTagName('IDNumber')[0] === null)) {
                    managementComment = managementComment.concat("ID Number", key.getElementsByTagName('IDNumber')[0].textContent)
                }
                if (key.getElementsByTagName('DateAppointed').length > 0) {
                    if (!(key.getElementsByTagName('DateAppointed')[0].getElementsByTagName('DateStr')[0] === undefined || key.getElementsByTagName('DateAppointed')[0].getElementsByTagName('DateStr')[0] === null)) {
                        managementComment = managementComment.concat("\\nData  appointed", key.getElementsByTagName('DateAppointed')[0].getElementsByTagName('DateStr')[0].textContent)
                    }
                }
                if (managementComment === "") {
                    commonJson['management_international_comments'].push("NA");
                }
                else {
                    commonJson['management_international_comments'].push(managementComment)
                }
            }
        }
    }


    //------------Business Affilites---------------
    if (xmlDoc.getElementsByTagName("CorporateAffiliations").length > 0) {
        if (xmlDoc.getElementsByTagName("CorporateAffiliations")[0].getElementsByTagName("Affiliations").length > 0) {
            var businessAffiliates = xmlDoc.getElementsByTagName("CorporateAffiliations")[0].getElementsByTagName("Affiliations")[0];
            if (!(businessAffiliates === undefined || businessAffiliates === null)) {
                for (var i = 0; i < businessAffiliates.getElementsByTagName("Affiliations").length; i++) {

                    let key = businessAffiliates.getElementsByTagName("Affiliations")[i];
                    if (!(key.getElementsByTagName('Name')[0] === undefined || key.getElementsByTagName('Name')[0] === null)) {
                        commonJson["business_affiliates_international_name"].push(key.getElementsByTagName('Name')[0].textContent);
                    }
                    else {
                        commonJson["business_affiliates_international_name"].push("NA")
                    }
                    if (!(key.getElementsByTagName('AffiliateTypes')[0].getElementsByTagName('AffiliateType')[0] === undefined || key.getElementsByTagName('AffiliateTypes')[0].getElementsByTagName('AffiliateType')[0] === null)) {
                        commonJson["business_affiliates_international_affiliation_type"].push(key.getElementsByTagName('AffiliateTypes')[0].getElementsByTagName('AffiliateType')[0].textContent);
                    }
                    else {
                        commonJson["business_affiliates_international_affiliation_type"].push("NA")
                    }
                    if (!(key.getElementsByTagName('Address')[0] === undefined || key.getElementsByTagName('Address')[0] === null)) {
                        commonJson["business_affiliates_international_address"].push(key.getElementsByTagName('Address')[0].textContent);
                    }
                    else {
                        commonJson["business_affiliates_international_address"].push("NA")
                    }
                    commonJson["business_affiliates_international_comments"].push("NA");

                }
            }
        }
    }

    if (xmlDoc.getElementsByTagName("BankingAndFinancing").length > 0) {
        if (xmlDoc.getElementsByTagName("BankingAndFinancing")[0].getElementsByTagName("Banks").length > 0) {
            //-------------BAnk Details--------------
            var bankDetails = xmlDoc.getElementsByTagName("BankingAndFinancing")[0].getElementsByTagName("Banks")[0];
            if (!(bankDetails === undefined || bankDetails === null)) {
                for (var i = 0; i < bankDetails.getElementsByTagName("BankItem").length; i++) {

                    let key = bankDetails.getElementsByTagName("BankItem")[i];
                    if (!(key.getElementsByTagName('BankName')[0] === undefined || key.getElementsByTagName('BankName')[0] === null)) {
                        commonJson['banking_international_name'].push(key.getElementsByTagName('BankName')[0].textContent);
                    }
                    else {
                        commonJson['banking_international_name'].push("NA")
                    }
                    if (!(key.getElementsByTagName('Address')[0] === undefined || key.getElementsByTagName('Address')[0] === null)) {
                        commonJson['banking_international_address'].push(key.getElementsByTagName('Address')[0].textContent);
                    }
                    else {
                        commonJson['banking_international_address'].push("NA")
                    }
                    commonJson['banking_international_comment'].push("NA");

                }
            }
        }
    }

    //------LEGAL RECORDS-----
    if (xmlDoc.getElementsByTagName("LegalFilings").length > 0) {
        if (xmlDoc.getElementsByTagName("LegalFilings")[0].getElementsByTagName("BankruptcyFilings").length > 0) {
            if (!(xmlDoc.getElementsByTagName("LegalFilings")[0].getElementsByTagName("BankruptcyFilings")[0] === undefined || xmlDoc.getElementsByTagName("LegalFilings")[0].getElementsByTagName("BankruptcyFilings")[0] === null)) {
                commonJson["bankruptcy_Filings_International"] = xmlDoc.getElementsByTagName("LegalFilings")[0].getElementsByTagName("BankruptcyFilings")[0].textContent
            }
            if (!(xmlDoc.getElementsByTagName("LegalFilings")[0].getElementsByTagName("CourtJudgements")[0] === undefined || xmlDoc.getElementsByTagName("LegalFilings")[0].getElementsByTagName("CourtJudgements")[0] === null)) {
                commonJson["court_Judgements_International"] = xmlDoc.getElementsByTagName("LegalFilings")[0].getElementsByTagName("CourtJudgements")[0].textContent
            }
            if (!(xmlDoc.getElementsByTagName("LegalFilings")[0].getElementsByTagName("LegalCases")[0] === undefined || xmlDoc.getElementsByTagName("LegalFilings")[0].getElementsByTagName("LegalCases")[0] === null)) {
                commonJson["legal_Cases_International"] = xmlDoc.getElementsByTagName("LegalFilings")[0].getElementsByTagName("LegalCases")[0].textContent
            }
            if (!(xmlDoc.getElementsByTagName("LegalFilings")[0].getElementsByTagName("TaxLiens")[0] === undefined || xmlDoc.getElementsByTagName("LegalFilings")[0].getElementsByTagName("TaxLiens")[0] === null)) {
                commonJson["tax_Liens_International"] = xmlDoc.getElementsByTagName("LegalFilings")[0].getElementsByTagName("TaxLiens")[0].textContent
            }
            if (!(xmlDoc.getElementsByTagName("LegalFilings")[0].getElementsByTagName("Other")[0] === undefined || xmlDoc.getElementsByTagName("LegalFilings")[0].getElementsByTagName("Other")[0] === null)) {
                commonJson["others_Legal_International"] = xmlDoc.getElementsByTagName("LegalFilings")[0].getElementsByTagName("Other")[0].textContent
            }
        }
    }

    //-----payment Exper-----
    if (xmlDoc.getElementsByTagName("Payments").length > 0) {
        let paymentExper = "";
        if (!(xmlDoc.getElementsByTagName("Payments")[0].getElementsByTagName("DebtCollections")[0] === undefined || xmlDoc.getElementsByTagName("Payments")[0].getElementsByTagName("DebtCollections")[0] === null)) {
            paymentExper = paymentExper.concat(xmlDoc.getElementsByTagName("Payments")[0].getElementsByTagName("DebtCollections")[0].textContent, "\\n")
        }
        if (!(xmlDoc.getElementsByTagName("Payments")[0].getElementsByTagName("PaymentBehaviour")[0] === undefined || xmlDoc.getElementsByTagName("Payments")[0].getElementsByTagName("PaymentBehaviour")[0] === null)) {
            paymentExper = paymentExper.concat(xmlDoc.getElementsByTagName("Payments")[0].getElementsByTagName("PaymentBehaviour")[0].textContent)
        }
        commonJson["payment_Experience_International"] = paymentExper;
    }


    //-----------------------
    //console.log(commonJson);
    return commonJson;
}

export const infocreditAdapter = (caseId, counterpartyId, xmlDoc) => {
    commonJson['caseId'] = caseId;
    commonJson['counterpartyId'] = counterpartyId;
    //------Enquiry------
    var countryNameCusSupcheck = "";
    if (xmlDoc.getElementsByTagName("company").length > 0) {
        if (!(xmlDoc.getElementsByTagName("company")[0].getElementsByTagName("english_name")[0] === undefined || xmlDoc.getElementsByTagName("company")[0].getElementsByTagName("english_name")[0] === null)) {
            commonJson["name_of_Entity_Investigated_Details_International"] = xmlDoc.getElementsByTagName("company")[0].getElementsByTagName("english_name")[0].textContent
        }

        let investigatedaddress = ""
        if (xmlDoc.getElementsByTagName("company")[0].getElementsByTagName("address").length > 0) {
            if (!(xmlDoc.getElementsByTagName("company")[0].getElementsByTagName("address")[0].getElementsByTagName("building_name")[0] === undefined || xmlDoc.getElementsByTagName("company")[0].getElementsByTagName("address")[0].getElementsByTagName("building_name")[0] === null)) {
                investigatedaddress = investigatedaddress.concat(xmlDoc.getElementsByTagName("company")[0].getElementsByTagName("address")[0].getElementsByTagName("building_name")[0].textContent, " ")
            }

            if (!(xmlDoc.getElementsByTagName("company")[0].getElementsByTagName("address")[0].getElementsByTagName("street")[0] === undefined || xmlDoc.getElementsByTagName("company")[0].getElementsByTagName("address")[0].getElementsByTagName("street")[0] === null)) {
                investigatedaddress = investigatedaddress.concat(xmlDoc.getElementsByTagName("company")[0].getElementsByTagName("address")[0].getElementsByTagName("street")[0].textContent, " ")
            }
            if (!(xmlDoc.getElementsByTagName("company")[0].getElementsByTagName("address")[0].getElementsByTagName("district_name")[0] === undefined || xmlDoc.getElementsByTagName("company")[0].getElementsByTagName("address")[0].getElementsByTagName("district_name")[0] === null)) {
                investigatedaddress = investigatedaddress.concat(xmlDoc.getElementsByTagName("company")[0].getElementsByTagName("address")[0].getElementsByTagName("district_name")[0].textContent, " ")
            }

            if (!(xmlDoc.getElementsByTagName("company")[0].getElementsByTagName("address")[0].getElementsByTagName("po_box")[0] === undefined || xmlDoc.getElementsByTagName("company")[0].getElementsByTagName("address")[0].getElementsByTagName("po_box")[0] === null)) {
                investigatedaddress = investigatedaddress.concat("Po Box No.", xmlDoc.getElementsByTagName("company")[0].getElementsByTagName("address")[0].getElementsByTagName("po_box")[0].textContent)
            }

            commonJson["address_of_Entity_Investigated_Details_International"] = investigatedaddress
            if (!(xmlDoc.getElementsByTagName("company")[0].getElementsByTagName("address")[0].getElementsByTagName("country_name")[0] === undefined || xmlDoc.getElementsByTagName("company")[0].getElementsByTagName("address")[0].getElementsByTagName("country_name")[0] === null)) {
                commonJson['country_Investigated_Details_International'] = xmlDoc.getElementsByTagName("company")[0].getElementsByTagName("address")[0].getElementsByTagName("country_name")[0].textContent
                countryNameCusSupcheck = xmlDoc.getElementsByTagName("company")[0].getElementsByTagName("address")[0].getElementsByTagName("country_name")[0].textContent
            }
        }

        if (xmlDoc.getElementsByTagName("company")[0].getElementsByTagName("contact_info").length > 0) {
            if (!(xmlDoc.getElementsByTagName("company")[0].getElementsByTagName("contact_info") === undefined || xmlDoc.getElementsByTagName("company")[0].getElementsByTagName("contact_info") === null)) {
                for (var i = 0; i < xmlDoc.getElementsByTagName("company")[0].getElementsByTagName("contact_info").length; i++) {
                    let key = xmlDoc.getElementsByTagName("company")[0].getElementsByTagName("contact_info")[i];
                    if (!(key.getElementsByTagName("type_name")[0] === undefined || key.getElementsByTagName("type_name")[0] === null) && key.getElementsByTagName("type_name")[0].textContent === "Email") {
                        commonJson["email_ID_Investigated_Details_International"] = key.getElementsByTagName("info")[0].textContent
                    }
                    if (!(key.getElementsByTagName("type_name")[0] === undefined || key.getElementsByTagName("type_name")[0] === null) && key.getElementsByTagName("type_name")[0].textContent === "Telephone") {
                        commonJson["telephone_Number_Investigated_Details_International"] = key.getElementsByTagName("info")[0].textContent
                    }
                    if (!(key.getElementsByTagName("type_name")[0] === undefined || key.getElementsByTagName("type_name")[0] === null) && key.getElementsByTagName("type_name")[0].textContent === "Website") {
                        commonJson["website_Investigated_Details_International"] = key.getElementsByTagName("info")[0].textContent
                    }
                    if (!(key.getElementsByTagName("type_name")[0] === undefined || key.getElementsByTagName("type_name")[0] === null) && key.getElementsByTagName("type_name")[0].textContent === "Fax") {
                        commonJson["other_Investigated_Details_International"] = key.getElementsByTagName("info")[0].textContent
                    }
                }
            }
        }
        //-------business BAckground-------------
        if (!(xmlDoc.getElementsByTagName("company")[0].getElementsByTagName("english_name")[0] === undefined || xmlDoc.getElementsByTagName("company")[0].getElementsByTagName("english_name")[0] === null)) {
            commonJson["name_International"] = xmlDoc.getElementsByTagName("company")[0].getElementsByTagName("english_name")[0].textContent;
        }

        if (!(xmlDoc.getElementsByTagName("company")[0].getElementsByTagName("name")[0] === undefined || xmlDoc.getElementsByTagName("company")[0].getElementsByTagName("name")[0] === null)) {
            commonJson["trading_Name_International"] = xmlDoc.getElementsByTagName("company")[0].getElementsByTagName("name")[0].textContent;
        }

        //if(xmlDoc.getElementsByTagName("RegistryData")[0].getElementsByTagName("PreviousName")[0]!==undefined){
        //commonJson["former_Name_International"]=xmlDoc.getElementsByTagName("RegistryData")[0].getElementsByTagName("PreviousName")[0].textContent;}
        //else{
        commonJson["former_Name_International"] = "NA"
        //}
        let address = ""
        if (xmlDoc.getElementsByTagName("company")[0].getElementsByTagName("address").length > 0) {
            if (!(xmlDoc.getElementsByTagName("company")[0].getElementsByTagName("address")[0].getElementsByTagName("building_name")[0] === undefined || xmlDoc.getElementsByTagName("company")[0].getElementsByTagName("address")[0].getElementsByTagName("building_name")[0] === null)) {
                address = address.concat(xmlDoc.getElementsByTagName("company")[0].getElementsByTagName("address")[0].getElementsByTagName("building_name")[0].textContent, " ")
            }

            if (!(xmlDoc.getElementsByTagName("company")[0].getElementsByTagName("address")[0].getElementsByTagName("street")[0] === undefined || xmlDoc.getElementsByTagName("company")[0].getElementsByTagName("address")[0].getElementsByTagName("street")[0] === null)) {
                address = address.concat(xmlDoc.getElementsByTagName("company")[0].getElementsByTagName("address")[0].getElementsByTagName("street")[0].textContent, " ")
            }
            if (!(xmlDoc.getElementsByTagName("company")[0].getElementsByTagName("address")[0].getElementsByTagName("district_name")[0] === undefined || xmlDoc.getElementsByTagName("company")[0].getElementsByTagName("address")[0].getElementsByTagName("district_name")[0] === null)) {
                address = address.concat(xmlDoc.getElementsByTagName("company")[0].getElementsByTagName("address")[0].getElementsByTagName("district_name")[0].textContent, " ")
            }

            if (!(xmlDoc.getElementsByTagName("company")[0].getElementsByTagName("address")[0].getElementsByTagName("po_box")[0] === undefined || xmlDoc.getElementsByTagName("company")[0].getElementsByTagName("address")[0].getElementsByTagName("po_box")[0] === null)) {
                address = address.concat("Po Box No.", xmlDoc.getElementsByTagName("company")[0].getElementsByTagName("address")[0].getElementsByTagName("po_box")[0].textContent)
            }
        }
        commonJson["address_International"] = address

        if (!(xmlDoc.getElementsByTagName("company")[0].getElementsByTagName("legal_form_name")[0] === undefined || xmlDoc.getElementsByTagName("company")[0].getElementsByTagName("legal_form_name")[0] === null)) {
            commonJson["type_of_Company_International"] = xmlDoc.getElementsByTagName("company")[0].getElementsByTagName("legal_form_name")[0].textContent;
        }

        if (!(xmlDoc.getElementsByTagName("company")[0].getElementsByTagName("registration_date")[0] === undefined || xmlDoc.getElementsByTagName("company")[0].getElementsByTagName("registration_date")[0] === null)) {
            commonJson["year_Established_International"] = xmlDoc.getElementsByTagName("company")[0].getElementsByTagName("registration_date")[0].textContent;
        }

        let allstatustag = [];
        allstatustag = xmlDoc.getElementsByTagName("company")[0].getElementsByTagName("status")
        if (allstatustag.length > 0) {
            //console.log(allstatustag[allstatustag.length-1])
            commonJson["company_Status_International"] = allstatustag[allstatustag.length - 1].textContent;
        }

        if (xmlDoc.getElementsByTagName("company")[0].getElementsByTagName("administrators").length > 0) {
            if (xmlDoc.getElementsByTagName("company")[0].getElementsByTagName("administrators")[0].getElementsByTagName("employees").length > 0) {
                if (!(xmlDoc.getElementsByTagName("company")[0].getElementsByTagName("administrators")[0].getElementsByTagName("employees")[0].getElementsByTagName("full_time_num")[0] === undefined || xmlDoc.getElementsByTagName("company")[0].getElementsByTagName("administrators")[0].getElementsByTagName("employees")[0].getElementsByTagName("full_time_num")[0] === null)) {
                    commonJson["employee_Size_International"] = xmlDoc.getElementsByTagName("company")[0].getElementsByTagName("administrators")[0].getElementsByTagName("employees")[0].getElementsByTagName("full_time_num")[0].textContent;
                }
            }
        }
        let registerNumber = "";

        if (!(xmlDoc.getElementsByTagName("company")[0].getElementsByTagName("registration_id")[0] === undefined || xmlDoc.getElementsByTagName("company")[0].getElementsByTagName("registration_id")[0] === null)) {
            registerNumber = registerNumber.concat(xmlDoc.getElementsByTagName("company")[0].getElementsByTagName("registration_id")[0].textContent, " ")

        }

        commonJson['registration_Number_International'] = registerNumber;
        if (!(xmlDoc.getElementsByTagName("company")[0].getElementsByTagName("registration_date")[xmlDoc.getElementsByTagName("company")[0].getElementsByTagName("registration_date").length - 1] === undefined || xmlDoc.getElementsByTagName("company")[0].getElementsByTagName("registration_date")[xmlDoc.getElementsByTagName("company")[0].getElementsByTagName("registration_date").length - 1] === null)) {
            commonJson['year_Established_International'] = xmlDoc.getElementsByTagName("company")[0].getElementsByTagName("registration_date")[xmlDoc.getElementsByTagName("company")[0].getElementsByTagName("registration_date").length - 1].textContent

        }


        let otherIdentifiers = "";
        if (!(xmlDoc.getElementsByTagName("company")[0].getElementsByTagName("vat_number")[0] === undefined || xmlDoc.getElementsByTagName("company")[0].getElementsByTagName("vat_number")[0] === null)) {
            if (xmlDoc.getElementsByTagName("company")[0].getElementsByTagName("vat_number")[0].textContent.length > 0) {
                otherIdentifiers = otherIdentifiers.concat("Tax Reg No. ", xmlDoc.getElementsByTagName("company")[0].getElementsByTagName("vat_number")[0].textContent)
            }
        }
        if (!(xmlDoc.getElementsByTagName("company")[0].getElementsByTagName("membership_number")[0] === undefined || xmlDoc.getElementsByTagName("company")[0].getElementsByTagName("membership_number")[0] === null)) {
            if (xmlDoc.getElementsByTagName("company")[0].getElementsByTagName("membership_number")[0].textContent.length > 0) {
                otherIdentifiers = otherIdentifiers.concat("\\nMembership No.:  ", xmlDoc.getElementsByTagName("company")[0].getElementsByTagName("membership_number")[0].textContent)
            }
        }
        if (!(xmlDoc.getElementsByTagName("company")[0].getElementsByTagName("trading_license_number")[0] === undefined || xmlDoc.getElementsByTagName("company")[0].getElementsByTagName("trading_license_number")[0] === null)) {
            if (xmlDoc.getElementsByTagName("company")[0].getElementsByTagName("trading_license_number")[0].textContent.length > 0) {
                otherIdentifiers = otherIdentifiers.concat("\\nLicense  No.:  ", xmlDoc.getElementsByTagName("company")[0].getElementsByTagName("trading_license_number")[0].textContent)
            }
        }
        if (!(xmlDoc.getElementsByTagName("company")[0].getElementsByTagName("trading_license_number_expdate")[0] === undefined || xmlDoc.getElementsByTagName("company")[0].getElementsByTagName("trading_license_number_expdate")[0] === null)) {
            if (xmlDoc.getElementsByTagName("company")[0].getElementsByTagName("trading_license_number_expdate")[0].textContent.length > 0) {
                otherIdentifiers = otherIdentifiers.concat("\\nExpiry Date.:  ", xmlDoc.getElementsByTagName("company")[0].getElementsByTagName("trading_license_number_expdate")[0].textContent)
            }
        }
        commonJson['other_Identifiers_International'] = otherIdentifiers;



        //-------line of business -----
        let lineofbusiness = "";

        if (!(xmlDoc.getElementsByTagName("company")[0].getElementsByTagName("line_of_business")[0] === undefined || xmlDoc.getElementsByTagName("company")[0].getElementsByTagName("line_of_business")[0] === null)) {
            lineofbusiness = lineofbusiness.concat(xmlDoc.getElementsByTagName("company")[0].getElementsByTagName("line_of_business")[0].textContent)
        }
        if (xmlDoc.getElementsByTagName("company")[0].getElementsByTagName("activities").length > 0) {
            var linebusiness = xmlDoc.getElementsByTagName("company")[0].getElementsByTagName("activities");
            if (linebusiness !== undefined) {
                for (var i = 0; i < linebusiness.length; i++) {

                    let key = linebusiness[i];
                    if (i === 0) {
                        lineofbusiness = lineofbusiness.concat("\nNACE Code - Discription\n")
                    }
                    if (!(key.getElementsByTagName('nace')[0] === undefined || key.getElementsByTagName('nace')[0] === null)) {
                        lineofbusiness = lineofbusiness.concat(key.getElementsByTagName('nace')[0].textContent, " - ");
                    }
                    else {
                        lineofbusiness = lineofbusiness.concat("    - ");
                    }
                    if (!(key.getElementsByTagName('name')[0] === undefined || key.getElementsByTagName('name')[0] === null)) {
                        lineofbusiness = lineofbusiness.concat(key.getElementsByTagName('name')[0].textContent, "\n");
                    }
                    else {
                        lineofbusiness = lineofbusiness.concat("    \n");
                    }
                }
            }
        }
        commonJson["line_of_Business_International"] = lineofbusiness

        //-----Share holdiong
        if (xmlDoc.getElementsByTagName("company")[0].getElementsByTagName("shareholders").length > 0) {
            var shareholder = xmlDoc.getElementsByTagName("company")[0].getElementsByTagName("shareholders");
            if (shareholder !== undefined) {
                for (var i = 0; i < shareholder.length; i++) {

                    let key = shareholder[i];
                    if (!(key.getElementsByTagName('holder_name')[0] === undefined || key.getElementsByTagName('holder_name')[0] === null)) {
                        commonJson['shareholding_international_shareholder_name'].push(key.getElementsByTagName('holder_name')[0].textContent);
                    }
                    else {
                        commonJson['shareholding_international_shareholder_name'].push("NA")
                    }
                    if (!(key.getElementsByTagName('sharespercent')[0] === undefined || key.getElementsByTagName('sharespercent')[0] === null)) {
                        commonJson['shareholding_international_shareholding'].push(key.getElementsByTagName('sharespercent')[0].textContent);
                    }
                    else {
                        commonJson['shareholding_international_shareholding'].push("NA")
                    }
                    if (!(key.getElementsByTagName('country_name')[0] === undefined || key.getElementsByTagName('country_name')[0] === null)) {
                        commonJson['shareholding_international_nationality'].push(key.getElementsByTagName('country_name')[0].textContent);
                    }
                    else {
                        commonJson['shareholding_international_nationality'].push("NA")
                    }

                }
            }
        }

        //---------------managementStaff-----------------
        var managementPromoterDirectors = xmlDoc.getElementsByTagName("company")[0];
        if (!(managementPromoterDirectors === undefined || managementPromoterDirectors === null)) {
            for (var i = 0; i < managementPromoterDirectors.getElementsByTagName("associated_people").length; i++) {

                let key = managementPromoterDirectors.getElementsByTagName("associated_people")[i];
                if (!(key.getElementsByTagName('person_name')[0] === undefined || key.getElementsByTagName('person_name')[0] === null)) {
                    commonJson['management_international_name'].push(key.getElementsByTagName('person_name')[0].textContent);
                }
                else {
                    commonJson['management_international_name'].push("NA")
                }
                let designation = "";
                if (!(key.getElementsByTagName('occupation')[0] === undefined || key.getElementsByTagName('occupation')[0] === null)) {
                    designation = designation.concat(key.getElementsByTagName('occupation')[0].textContent, " ")
                }
                if (!(key.getElementsByTagName('role')[0] === undefined || key.getElementsByTagName('role')[0] === null)) {
                    designation = designation.concat(key.getElementsByTagName('role')[0].textContent, " ")
                }
                if (designation !== "") {
                    commonJson['management_international_designation'].push(designation)
                }

                else {
                    commonJson['management_international_designation'].push("NA")
                }
                let managementInternationalComment = "";
                if (!(key.getElementsByTagName('country_name')[0] === undefined || key.getElementsByTagName('country_name')[0] === null)) {
                    managementInternationalComment = managementInternationalComment.concat("Nationality :", key.getElementsByTagName('country_name')[0].textContent, "\n");
                }

                if (!(key.getElementsByTagName('comment')[0] === undefined || key.getElementsByTagName('comment')[0] === null)) {
                    managementInternationalComment.concat(key.getElementsByTagName('comment')[0].textContent);
                }
                commonJson['management_international_comments'].push(managementInternationalComment)
            }
        }


        //------------Business Affilites---------------
        var businessAffiliates = xmlDoc.getElementsByTagName("company")[0].getElementsByTagName("associated_companies");

        if (!(businessAffiliates === undefined || businessAffiliates === null)) {
            for (var i = 0; i < businessAffiliates.length; i++) {

                let key = businessAffiliates[i];
                if (!(key.getElementsByTagName('role')[0] === undefined || key.getElementsByTagName('role')[0] === null)) {
                    if (key.getElementsByTagName('role')[0].textContent.toUpperCase() === "SUPPLIER") {
                        if (!(key.getElementsByTagName('country_name')[0] === undefined || key.getElementsByTagName('country_name')[0] === null)) {
                            if (key.getElementsByTagName('country_name')[0].textContent.toUpperCase() === countryNameCusSupcheck.toUpperCase()) {
                                if (!(key.getElementsByTagName('counterpart_name')[0] === undefined || key.getElementsByTagName('counterpart_name')[0] === null)) {
                                    commonJson["supplier_international_domestic_suppliers"].push(key.getElementsByTagName('counterpart_name')[0].textContent);
                                    commonJson["supplier_international_overseas_suppliers"].push("NA")

                                }
                                else {
                                    commonJson["supplier_international_domestic_suppliers"].push("NA")
                                }

                            }
                            else {

                                if (!(key.getElementsByTagName('counterpart_name')[0] === undefined || key.getElementsByTagName('counterpart_name')[0] === null)) {
                                    commonJson["supplier_international_overseas_suppliers"].push(key.getElementsByTagName('counterpart_name')[0].textContent);
                                    commonJson["supplier_international_domestic_suppliers"].push("NA")
                                }
                                else {
                                    commonJson["supplier_international_overseas_suppliers"].push("NA")
                                }


                            }
                        }

                    }
                    //------------
                    else if (key.getElementsByTagName('role')[0].textContent.toUpperCase() === "CUSTOMER") {
                        if (!(key.getElementsByTagName('country_name')[0] === undefined || key.getElementsByTagName('country_name')[0] === null)) {
                            if (key.getElementsByTagName('country_name')[0].textContent.toUpperCase() === countryNameCusSupcheck.toUpperCase()) {
                                if (!(key.getElementsByTagName('counterpart_name')[0] === undefined || key.getElementsByTagName('counterpart_name')[0] === null)) {
                                    commonJson["customers_international_domestic_customer"].push(key.getElementsByTagName('counterpart_name')[0].textContent);
                                    commonJson["customers_international_export_customer"].push("NA")
                                }
                                else {
                                    commonJson["customers_international_domestic_customer"].push("NA")
                                }

                            }
                            else {

                                if (!(key.getElementsByTagName('counterpart_name')[0] === undefined || key.getElementsByTagName('counterpart_name')[0] === null)) {
                                    commonJson["customers_international_export_customer"].push(key.getElementsByTagName('counterpart_name')[0].textContent);
                                    commonJson["customers_international_domestic_customer"].push("NA")
                                }
                                else {
                                    commonJson["customers_international_export_customer"].push("NA")
                                }


                            }
                        }
                    }
                    else {
                        if (!(key.getElementsByTagName('counterpart_name')[0] === undefined || key.getElementsByTagName('counterpart_name')[0] === null)) {
                            commonJson["business_affiliates_international_name"].push(key.getElementsByTagName('counterpart_name')[0].textContent);
                        }
                        else {
                            commonJson["business_affiliates_international_name"].push("NA")
                        }
                        if (!(key.getElementsByTagName('country_name')[0] === undefined || key.getElementsByTagName('country_name')[0] === null)) {
                            commonJson["business_affiliates_international_address"].push(key.getElementsByTagName('country_name')[0].textContent);
                        }
                        else {
                            commonJson["business_affiliates_international_address"].push("NA")
                        }
                        let businessAffiliatesComment = "";
                        if (!(key.getElementsByTagName('role')[0] === undefined || key.getElementsByTagName('role')[0] === null)) {
                            businessAffiliatesComment = businessAffiliatesComment.concat("Affiliation Type: ", key.getElementsByTagName('role')[0].textContent, "\n");
                        }
                        if (!(key.getElementsByTagName('comment')[0] === undefined || key.getElementsByTagName('comment')[0] === null)) {
                            businessAffiliatesComment.concat(key.getElementsByTagName('comment')[0].textContent)
                        }
                        commonJson["business_affiliates_international_comments"].push(businessAffiliatesComment);
                    }
                }
            }
        }
        //-------------BAnk Details--------------
        var bankDetails = xmlDoc.getElementsByTagName("company")[0].getElementsByTagName("bank_accounts");
        if (!(bankDetails === undefined || bankDetails === null)) {
            for (var i = 0; i < bankDetails.length; i++) {

                let key = bankDetails[i];
                if (!(key.getElementsByTagName('bank_name')[0] === undefined || key.getElementsByTagName('bank_name')[0] === null)) {
                    commonJson['banking_international_name'].push(key.getElementsByTagName('bank_name')[0].textContent);
                }
                else {
                    commonJson['banking_international_name'].push("NA")
                }
                let bankingInternationalComment = "";
                if (!(key.getElementsByTagName('Address')[0] === undefined || key.getElementsByTagName('Address')[0] === null)) {
                    bankingInternationalComment = bankingInternationalComment.concat("Address: :", key.getElementsByTagName('Address')[0].textContent);
                }
                commonJson['banking_international_comment'].push(bankingInternationalComment);

            }
        }
        //----auditors-----
        if (!(xmlDoc.getElementsByTagName("company")[0].getElementsByTagName("auditor")[0] === undefined || xmlDoc.getElementsByTagName("company")[0].getElementsByTagName("auditor")[0] === null)) {
            commonJson["auditors_International"] = xmlDoc.getElementsByTagName("company")[0].getElementsByTagName("auditor")[0].textContent;
        }
        //---------Loactions----------------
        var locations = xmlDoc.getElementsByTagName("company")[0].getElementsByTagName("branches");
        if (!(locations === undefined || locations === null)) {
            for (var i = 0; i < locations.length; i++) {

                let key = locations[i];
                let address = "";
                if (!(key.getElementsByTagName('address')[0].getElementsByTagName('building_name')[0] === undefined || key.getElementsByTagName('address')[0].getElementsByTagName('building_name')[0] === null)) {
                    address = address.concat(key.getElementsByTagName('address')[0].getElementsByTagName('building_name')[0].textContent, " ")
                }
                if (!(key.getElementsByTagName('address')[0].getElementsByTagName('city_name')[0] === undefined || key.getElementsByTagName('address')[0].getElementsByTagName('city_name')[0] === null)) {
                    address = address.concat(key.getElementsByTagName('address')[0].getElementsByTagName('city_name')[0].textContent, " ")
                }
                if (!(key.getElementsByTagName('address')[0].getElementsByTagName('country_name')[0] === undefined || key.getElementsByTagName('address')[0].getElementsByTagName('country_name')[0] === null)) {
                    address = address.concat(" ", key.getElementsByTagName('address')[0].getElementsByTagName('country_name')[0].textContent);
                }

                commonJson["locations_international_address"].push(address);

                if (!(key.getElementsByTagName('operates_as')[0] === undefined || key.getElementsByTagName('operates_as')[0] === null)) {
                    commonJson["locations_international_type"].push(key.getElementsByTagName('operates_as')[0].textContent);
                }
                else {
                    commonJson["locations_international_type"].push("NA");
                }

                commonJson["locations_international_comments"].push("NA");

            }
        }
        //-----payment Exper-----

        let paymentExperience = "";
        if (xmlDoc.getElementsByTagName("company")[0].getElementsByTagName("profile").length > 0) {
            if (xmlDoc.getElementsByTagName("company")[0].getElementsByTagName("profile")[0].getElementsByTagName("displaytype")[0] !== undefined) {
                paymentExperience = paymentExperience.concat(xmlDoc.getElementsByTagName("company")[0].getElementsByTagName("profile")[0].getElementsByTagName("displaytype")[0].textContent, "\n")
            }
        }

        if (xmlDoc.getElementsByTagName("company")[0].getElementsByTagName("profile").length > 0) {
            if (xmlDoc.getElementsByTagName("company")[0].getElementsByTagName("profile")[0].getElementsByTagName("display_comment")[0] !== undefined) {
                paymentExperience = paymentExperience.concat(xmlDoc.getElementsByTagName("company")[0].getElementsByTagName("profile")[0].getElementsByTagName("display_comment")[0].textContent)
            }
        }
        commonJson['payment_Experience_International'] = paymentExperience


        //----financial-----
        //----Balance Sheet & Profit and Loss
        if (!(xmlDoc.getElementsByTagName("company")[0].getElementsByTagName("financials")[0] === undefined || xmlDoc.getElementsByTagName("company")[0].getElementsByTagName("financials")[0] === null)) {
            let financialData = xmlDoc.getElementsByTagName("company")[0].getElementsByTagName("financials")
            var lableIndexArray = [];
            var profitlabeIndex = [];
            if (financialData !== undefined) {
                for (var i = 0; i < financialData.length; i++) {
                    if (i === 0) {
                        commonJson["elements_Balancesheet_international"].push("Year")
                        commonJson["elements_profit_and_loss_international"].push("Year")

                        if (financialData[i].getElementsByTagName("year")[0] !== undefined) {
                            commonJson["year1_balancesheet_international"].push(financialData[i].getElementsByTagName("year")[0].textContent)
                            commonJson["year1_profit_and_loss_international_"].push(financialData[i].getElementsByTagName("year")[0].textContent)
                        }
                        else {
                            commonJson["year1_balancesheet_international"].push("")
                            commonJson["year1_profit_and_loss_international_"].push("")
                        }
                    }
                    if (i === 1) {
                        if (financialData[i].getElementsByTagName("year")[0] !== undefined) {
                            commonJson["year2_balancesheet_international"].push(financialData[i].getElementsByTagName("year")[0].textContent)
                            commonJson["year2_profit_and_loss_international"].push(financialData[i].getElementsByTagName("year")[0].textContent)
                        }
                        else {
                            commonJson["year2_balancesheet_international"].push("")
                            commonJson["year2_profit_and_loss_international"].push("")
                        }
                    }
                    if (i === 2) {
                        if (financialData[i].getElementsByTagName("year")[0] !== undefined) {
                            commonJson["year3_balancesheet_international_"].push(financialData[i].getElementsByTagName("year")[0].textContent)
                            commonJson["year3_profit_and_loss_international"].push(financialData[i].getElementsByTagName("year")[0].textContent)
                        }
                        else {
                            commonJson["year3_balancesheet_international_"].push("")
                            commonJson["year3_profit_and_loss_international"].push("")
                        }
                    }
                    for (var j = 0; j < financialData[i].getElementsByTagName("data").length; j++) {
                        let key = financialData[i].getElementsByTagName("data")[j];
                        if (i === 0) {
                            if (key.getElementsByTagName("field_name")[0] !== undefined && key.getElementsByTagName("field_name").length > 0 && (key.getElementsByTagName("category_id")[0].textContent === "9" || key.getElementsByTagName("category_id")[0].textContent === "12")) {
                                commonJson["elements_Balancesheet_international"].push(key.getElementsByTagName("field_name")[0].textContent)
                                if (key.getElementsByTagName("value")[0] !== undefined && key.getElementsByTagName("value")[0].textContent.length > 0) {
                                    commonJson["year1_balancesheet_international"].push(key.getElementsByTagName("value")[0].textContent)
                                }
                                else {
                                    commonJson["year1_balancesheet_international"].push("0")
                                }
                                if (key.getElementsByTagName("is_label")[0] !== undefined && key.getElementsByTagName("is_label")[0].textContent === "1") {
                                    lableIndexArray.push(commonJson["elements_Balancesheet_international"].length - 1)
                                }
                            }
                            //-----Profit And Loss ----------
                            if (key.getElementsByTagName("field_name")[0] !== undefined && key.getElementsByTagName("field_name").length > 0 && (key.getElementsByTagName("category_id")[0].textContent === "10" || key.getElementsByTagName("category_id")[0].textContent === "13") && key.getElementsByTagName("is_label")[0].textContent === "0") {
                                commonJson["elements_profit_and_loss_international"].push(key.getElementsByTagName("field_name")[0].textContent)
                                if (key.getElementsByTagName("value")[0] !== undefined && key.getElementsByTagName("value")[0].textContent.length > 0) {
                                    commonJson["year1_profit_and_loss_international_"].push(key.getElementsByTagName("value")[0].textContent)
                                }
                                else {
                                    commonJson["year1_profit_and_loss_international_"].push("0")
                                }

                            }
                            //------
                        }

                        if (i === 1) {
                            if (key.getElementsByTagName("field_name").length > 0 && (key.getElementsByTagName("category_id")[0].textContent === "9" || key.getElementsByTagName("category_id")[0].textContent === "12")) {
                                if (commonJson["elements_Balancesheet_international"].includes(key.getElementsByTagName("field_name")[0].textContent)) {
                                    if (key.getElementsByTagName("value")[0] !== undefined && key.getElementsByTagName("value")[0].textContent.length > 0) {
                                        commonJson["year2_balancesheet_international"].push(key.getElementsByTagName("value")[0].textContent)
                                    }
                                    else {
                                        commonJson["year2_balancesheet_international"].push("0")
                                    }
                                }
                            }
                            //-----Profit And Loss----
                            if (key.getElementsByTagName("field_name").length > 0 && (key.getElementsByTagName("category_id")[0].textContent === "10" || key.getElementsByTagName("category_id")[0].textContent === "13")) {
                                if (commonJson["elements_profit_and_loss_international"].includes(key.getElementsByTagName("field_name")[0].textContent)) {
                                    if (key.getElementsByTagName("value")[0] !== undefined && key.getElementsByTagName("value")[0].textContent.length > 0) {
                                        commonJson["year2_profit_and_loss_international"].push(key.getElementsByTagName("value")[0].textContent)
                                    }
                                    else {
                                        commonJson["year2_profit_and_loss_international"].push("0")
                                    }
                                }
                            }
                            //------------
                        }
                        if (i === 2) {
                            if (key.getElementsByTagName("field_name").length > 0 && (key.getElementsByTagName("category_id")[0].textContent === "9" || key.getElementsByTagName("category_id")[0].textContent === "12")) {
                                if (commonJson["elements_Balancesheet_international"].includes(key.getElementsByTagName("field_name")[0].textContent)) {
                                    if (key.getElementsByTagName("value")[0] !== undefined && key.getElementsByTagName("value")[0].textContent.length > 0) {
                                        commonJson["year3_balancesheet_international_"].push(key.getElementsByTagName("value")[0].textContent)
                                    }
                                    else {
                                        commonJson["year3_balancesheet_international_"].push("0")
                                    }
                                }
                            }
                            //-----Profit And Loss----
                            if (key.getElementsByTagName("field_name").length > 0 && (key.getElementsByTagName("category_id")[0].textContent === "10" || key.getElementsByTagName("category_id")[0].textContent === "13")) {
                                if (commonJson["elements_profit_and_loss_international"].includes(key.getElementsByTagName("field_name")[0].textContent)) {
                                    if (key.getElementsByTagName("value")[0] !== undefined && key.getElementsByTagName("value")[0].textContent.length > 0) {
                                        commonJson["year3_profit_and_loss_international"].push(key.getElementsByTagName("value")[0].textContent)
                                    }
                                    else {
                                        commonJson["year3_profit_and_loss_international"].push("0")
                                    }
                                }
                            }
                            //------------
                        }
                    }
                }
                if (financialData.length === 1 && lableIndexArray.length > 0) {
                    var modifyyearoneArray = []
                    var modifyelementArray = []
                    for (var j = 0; j < commonJson["year1_balancesheet_international"].length; j++) {
                        if (commonJson["year1_balancesheet_international"][j] !== "0" && commonJson["year1_balancesheet_international"][j] !== "") {
                            modifyelementArray.push(commonJson["elements_Balancesheet_international"][j]);
                            modifyyearoneArray.push(commonJson["year1_balancesheet_international"][j])

                        }
                        else {
                            if (lableIndexArray.includes(j)) {
                                modifyelementArray.push(commonJson["elements_Balancesheet_international"][j]);
                                modifyyearoneArray.push(commonJson["year1_balancesheet_international"][j])
                            }
                        }
                    }
                    commonJson["elements_Balancesheet_international"] = modifyelementArray
                    commonJson["year1_balancesheet_international"] = modifyyearoneArray

                    //************  for profit and loss *******
                    var modifyprofitandlossyearoneArray = []
                    var modifyprofitandlosselementArray = []
                    for (var j = 0; j < commonJson["year1_profit_and_loss_international_"].length; j++) {
                        if (commonJson["year1_profit_and_loss_international_"][j] !== "0" && commonJson["year1_profit_and_loss_international_"][j] !== "") {
                            modifyprofitandlosselementArray.push(commonJson["elements_profit_and_loss_international"][j]);
                            modifyprofitandlossyearoneArray.push(commonJson["year1_profit_and_loss_international_"][j])

                        }

                    }
                    commonJson["elements_profit_and_loss_international"] = modifyprofitandlosselementArray
                    commonJson["year1_profit_and_loss_international_"] = modifyprofitandlossyearoneArray
                }

                //****************
                //-----------
                if (financialData.length === 2 && lableIndexArray.length > 0) {
                    var modifyyearoneArray = []
                    var modifyyeartwoArray = []
                    var modifyelementArray = []
                    for (var j = 0; j < commonJson["year1_balancesheet_international"].length; j++) {
                        if (commonJson["year1_balancesheet_international"][j] !== "0" && commonJson["year1_balancesheet_international"][j] !== "") {

                            modifyelementArray.push(commonJson["elements_Balancesheet_international"][j]);
                            modifyyearoneArray.push(commonJson["year1_balancesheet_international"][j]);
                            modifyyeartwoArray.push(commonJson["year2_balancesheet_international"][j])

                        }
                        else {
                            if (commonJson["year2_balancesheet_international"][j] !== "0" && commonJson["year2_balancesheet_international"][j] !== "") {
                                modifyelementArray.push(commonJson["elements_Balancesheet_international"][j]);
                                modifyyearoneArray.push(commonJson["year1_balancesheet_international"][j]);
                                modifyyeartwoArray.push(commonJson["year2_balancesheet_international"][j])
                            }
                            else {
                                if (lableIndexArray.includes(j)) {
                                    modifyelementArray.push(commonJson["elements_Balancesheet_international"][j]);
                                    modifyyearoneArray.push(commonJson["year1_balancesheet_international"][j]);
                                    modifyyeartwoArray.push(commonJson["year2_balancesheet_international"][j])
                                }
                            }
                        }
                    }
                    commonJson["year1_balancesheet_international"] = modifyyearoneArray
                    commonJson["year2_balancesheet_international"] = modifyyeartwoArray
                    commonJson["elements_Balancesheet_international"] = modifyelementArray

                    //**************forprofit and lose
                    var modifyprofitandlossyearoneArray = []
                    var modifyprofitandlosselementArray = []
                    var modifyprofitandlossyeartwoArray = []
                    for (var j = 0; j < commonJson["year1_profit_and_loss_international_"].length; j++) {
                        if (commonJson["year1_profit_and_loss_international_"][j] !== "0" && commonJson["year1_profit_and_loss_international_"][j] !== "") {

                            modifyprofitandlosselementArray.push(commonJson["elements_profit_and_loss_international"][j]);
                            modifyprofitandlossyearoneArray.push(commonJson["year1_profit_and_loss_international_"][j]);
                            modifyprofitandlossyeartwoArray.push(commonJson["year2_profit_and_loss_international"][j])

                        }
                        else {
                            if (commonJson["year2_profit_and_loss_international"][j] !== "0" && commonJson["year2_profit_and_loss_international"][j] !== "") {
                                modifyprofitandlosselementArray.push(commonJson["elements_profit_and_loss_international"][j]);
                                modifyprofitandlossyearoneArray.push(commonJson["year1_profit_and_loss_international_"][j]);
                                modifyprofitandlossyeartwoArray.push(commonJson["year2_profit_and_loss_international"][j])
                            }
                        }
                    }
                    commonJson["year1_profit_and_loss_international_"] = modifyprofitandlossyearoneArray
                    commonJson["year2_profit_and_loss_international"] = modifyprofitandlossyeartwoArray
                    commonJson["elements_profit_and_loss_international"] = modifyprofitandlosselementArray
                }
                //************
                //-----------
                if (financialData.length === 3 && lableIndexArray.length > 0) {
                    var modifyyearoneArray = []
                    var modifyyeartwoArray = []
                    var modifyelementArray = []
                    var modifythreeArray = []
                    for (var j = 0; j < commonJson["year1_balancesheet_international"].length; j++) {
                        if (commonJson["year1_balancesheet_international"][j] !== "0" && commonJson["year1_balancesheet_international"][j] !== "") {

                            modifyelementArray.push(commonJson["elements_Balancesheet_international"][j]);
                            modifyyearoneArray.push(commonJson["year1_balancesheet_international"][j]);
                            modifyyeartwoArray.push(commonJson["year2_balancesheet_international"][j]);
                            modifythreeArray.push(commonJson["year3_balancesheet_international_"][j]);

                        }
                        else {
                            if (commonJson["year2_balancesheet_international"][j] !== "0" && commonJson["year2_balancesheet_international"][j] !== "") {
                                modifyelementArray.push(commonJson["elements_Balancesheet_international"][j]);
                                modifyyearoneArray.push(commonJson["year1_balancesheet_international"][j]);
                                modifyyeartwoArray.push(commonJson["year2_balancesheet_international"][j]);
                                modifythreeArray.push(commonJson["year3_balancesheet_international_"][j]);
                            }
                            else {
                                if (commonJson["year3_balancesheet_international_"][j] !== "0" && commonJson["year3_balancesheet_international_"][j] !== "") {
                                    modifyelementArray.push(commonJson["elements_Balancesheet_international"][j]);
                                    modifyyearoneArray.push(commonJson["year1_balancesheet_international"][j]);
                                    modifyyeartwoArray.push(commonJson["year2_balancesheet_international"][j]);
                                    modifythreeArray.push(commonJson["year3_balancesheet_international_"][j]);
                                }
                                else {

                                    if (lableIndexArray.includes(j)) {
                                        modifyelementArray.push(commonJson["elements_Balancesheet_international"][j]);
                                        modifyyearoneArray.push(commonJson["year1_balancesheet_international"][j]);
                                        modifyyeartwoArray.push(commonJson["year2_balancesheet_international"][j]);
                                        modifythreeArray.push(commonJson["year3_balancesheet_international_"][j]);
                                    }

                                }
                            }
                        }
                    }
                    commonJson["year1_balancesheet_international"] = modifyyearoneArray
                    commonJson["year2_balancesheet_international"] = modifyyeartwoArray
                    commonJson["elements_Balancesheet_international"] = modifyelementArray
                    commonJson["year3_balancesheet_international_"] = modifythreeArray

                    //***************for profit and loss
                    var modifyprofitandlossyearoneArray = []
                    var modifyprofitandlosselementArray = []
                    var modifyprofitandlossyeartwoArray = []
                    var modifyprofitandlossthreeArray = []
                    for (var j = 0; j < commonJson["year1_profit_and_loss_international_"].length; j++) {
                        if (commonJson["year1_profit_and_loss_international_"][j] !== "0" && commonJson["year1_profit_and_loss_international_"][j] !== "") {

                            modifyprofitandlosselementArray.push(commonJson["elements_profit_and_loss_international"][j]);
                            modifyprofitandlossyearoneArray.push(commonJson["year1_profit_and_loss_international_"][j]);
                            modifyprofitandlossyeartwoArray.push(commonJson["year2_profit_and_loss_international"][j]);
                            modifyprofitandlossthreeArray.push(commonJson["year3_profit_and_loss_international"][j]);

                        }
                        else {
                            if (commonJson["year2_profit_and_loss_international"][j] !== "0" && commonJson["year2_profit_and_loss_international"][j] !== "") {
                                modifyprofitandlosselementArray.push(commonJson["elements_profit_and_loss_international"][j]);
                                modifyprofitandlossyearoneArray.push(commonJson["year1_profit_and_loss_international_"][j]);
                                modifyprofitandlossyeartwoArray.push(commonJson["year2_profit_and_loss_international"][j]);
                                modifyprofitandlossthreeArray.push(commonJson["year3_profit_and_loss_international"][j]);
                            }
                            else {
                                if (commonJson["year3_profit_and_loss_international"][j] !== "0" && commonJson["year3_profit_and_loss_international"][j] !== "") {
                                    modifyprofitandlosselementArray.push(commonJson["elements_profit_and_loss_international"][j]);
                                    modifyprofitandlossyearoneArray.push(commonJson["year1_profit_and_loss_international_"][j]);
                                    modifyprofitandlossyeartwoArray.push(commonJson["year2_profit_and_loss_international"][j]);
                                    modifyprofitandlossthreeArray.push(commonJson["year3_profit_and_loss_international"][j]);
                                }

                            }
                        }
                    }
                    commonJson["year1_profit_and_loss_international_"] = modifyprofitandlossyearoneArray
                    commonJson["year2_profit_and_loss_international"] = modifyprofitandlossyeartwoArray
                    commonJson["elements_profit_and_loss_international"] = modifyprofitandlosselementArray
                    commonJson["year3_profit_and_loss_international"] = modifyprofitandlossthreeArray
                    //****************
                }
                //--------------------
            }
        }
    }
    //-----------------
    //console.log(commonJson);
    return commonJson
}